
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cei05", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $132077623536365b$export$c037b66df971b916 = /*#__PURE__*/ (0, $42omo.createContext)({
    inFlightRequests: new Map(),
    setInFlightRequests: ()=>{}
});
function $132077623536365b$export$1bb2b4064846aef2() {
    return (0, $42omo.useContext)($132077623536365b$export$c037b66df971b916);
}
function $132077623536365b$export$afffe3cb36bf5e6e({ children: children }) {
    const inFlightRequestsRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(new Map());
    const setInFlightRequests = (0, $42omo.useCallback)((requestKey, value)=>{
        inFlightRequestsRef.current.set(requestKey, value);
    }, []);
    const contextValue = (0, $42omo.useMemo)(()=>({
            inFlightRequests: inFlightRequestsRef.current,
            setInFlightRequests: setInFlightRequests
        }), [
        setInFlightRequests
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($132077623536365b$export$c037b66df971b916.Provider, {
        value: contextValue,
        children: children
    });
}
module.exports["useUniversalCreateBFFContext"] = $132077623536365b$export$1bb2b4064846aef2;
module.exports["UniversalCreateBFFProvider"] = $132077623536365b$export$afffe3cb36bf5e6e;

});

parcelRegister("19BZl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $8e4be96129d634f8$var$defaultSectionExpansionContext = {
    sectionExpansionState: {},
    setSectionExpansionState: function() {}
};
const $8e4be96129d634f8$export$fc9ae5c4169099cb = (0, $42omo.createContext)($8e4be96129d634f8$var$defaultSectionExpansionContext);
function $8e4be96129d634f8$export$b316af36f410c3ff() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$fc9ae5c4169099cb);
}
const $8e4be96129d634f8$var$defaultFormControls = {
    load: function() {},
    reset: function() {},
    close: function() {},
    mixedItems: [],
    product: 'unknown',
    subProduct: undefined,
    suggestionConfig: {
        enabled: false
    },
    isNav4Enabled: true,
    crossAppCreationConfig: {
        enabled: false
    },
    sections: []
};
const $8e4be96129d634f8$export$39aa3c8950714d79 = (0, $42omo.createContext)($8e4be96129d634f8$var$defaultFormControls);
function $8e4be96129d634f8$export$56d95dc846453c64() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$39aa3c8950714d79);
}
const $8e4be96129d634f8$var$defaultFormControlsV2 = {
    load: function() {},
    reset: function() {},
    close: function() {}
};
const $8e4be96129d634f8$export$bde3acf5b7a2ab3c = (0, $42omo.createContext)($8e4be96129d634f8$var$defaultFormControlsV2);
function $8e4be96129d634f8$export$24cc61890c8f7885() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$bde3acf5b7a2ab3c);
}
const $8e4be96129d634f8$export$24aad8519b95b41b = (0, $42omo.createContext)({
    isV2Mode: false,
    items: [],
    product: 'unknown',
    subProduct: undefined,
    crossAppCreationConfig: {
        enabled: false
    },
    sections: [],
    suggestionConfig: {
        enabled: false
    },
    isNav4Enabled: true,
    preventClose: undefined,
    controlledOpen: undefined
});
function $8e4be96129d634f8$export$efa3856fc0e85e7f() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$24aad8519b95b41b);
}
function $8e4be96129d634f8$export$c7381b2490bb4d36() {
    const menuControlContext = (0, $42omo.useContext)($8e4be96129d634f8$export$39aa3c8950714d79);
    const menuStateContext = (0, $42omo.useContext)($8e4be96129d634f8$export$24aad8519b95b41b);
    // When FG is enabled, prefer new context
    if ((0, $dh538.fg)('navx_uc_context_refactor')) return menuStateContext;
    // Fall back to constructing state from the old MenuControlContext
    // isV2Mode is determined by whether sections array has items
    const isV2Mode = !!menuControlContext.sections?.length;
    return {
        isV2Mode: isV2Mode,
        items: menuControlContext.mixedItems,
        product: menuControlContext.product,
        subProduct: menuControlContext.subProduct,
        crossAppCreationConfig: menuControlContext.crossAppCreationConfig,
        sections: menuControlContext.sections,
        suggestionConfig: menuControlContext.suggestionConfig,
        isNav4Enabled: menuControlContext.isNav4Enabled,
        preventClose: undefined,
        controlledOpen: undefined
    };
}
function $8e4be96129d634f8$export$2cd627eaf555af8f() {
    const menuControlContext = (0, $42omo.useContext)($8e4be96129d634f8$export$39aa3c8950714d79);
    const menuControlV2Context = (0, $42omo.useContext)($8e4be96129d634f8$export$bde3acf5b7a2ab3c);
    // When FG is enabled, prefer new V2 context
    if ((0, $dh538.fg)('navx_uc_context_refactor')) return menuControlV2Context;
    // Fall back to old MenuControlContext
    return {
        load: menuControlContext.load,
        reset: menuControlContext.reset,
        close: menuControlContext.close
    };
}
module.exports["SectionExpansionContext"] = $8e4be96129d634f8$export$fc9ae5c4169099cb;
module.exports["useSectionExpansionContext"] = $8e4be96129d634f8$export$b316af36f410c3ff;
module.exports["MenuControlContext"] = $8e4be96129d634f8$export$39aa3c8950714d79;
module.exports["MenuControlContextV2"] = $8e4be96129d634f8$export$bde3acf5b7a2ab3c;
module.exports["MenuStateContext"] = $8e4be96129d634f8$export$24aad8519b95b41b;
module.exports["useMenuStateContext"] = $8e4be96129d634f8$export$efa3856fc0e85e7f;
module.exports["useUniversalCreateState"] = $8e4be96129d634f8$export$c7381b2490bb4d36;
module.exports["useUniversalCreateControl"] = $8e4be96129d634f8$export$2cd627eaf555af8f;

});

parcelRegister("9A2e6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $dh538 = parcelRequire("dh538");


var $49YLc = parcelRequire("49YLc");


var $5IDSL = parcelRequire("5IDSL");


var $jjCkw = parcelRequire("jjCkw");


var $19BZl = parcelRequire("19BZl");

function $31bd555df287b548$export$9e9b5b3f9c08ce57({ children: children, name: name, interactionId: interactionId, fallback: fallback = null, onError: onError, app: app }) {
    const { product: product, subProduct: subProduct } = (0, $19BZl.useMenuStateContext)();
    const { product: productV1, subProduct: subProductV1 } = (0, $19BZl.useUniversalCreateState)();
    const tags = {
        component: (0, $jjCkw.PACKAGE_PREFIX),
        subProduct: subProduct || subProductV1
    };
    const { handleError: handleError } = $31bd555df287b548$var$useConditionalNavBoundaryContext({
        location: name,
        disableSentry: false,
        disableAnalytics: true,
        onError: onError,
        sentryConfig: {
            product: app || product || productV1
        },
        interactionId: interactionId,
        tags: tags
    });
    const handleOnError = (0, $42omo.useCallback)(async (error)=>{
        if ((0, $dh538.fg)('navx_uc_sentry_enabled')) handleError(error);
        else onError?.(error);
        if ((0, $dh538.fg)('navx_uc_enable_sentry_console_debugging')) console.error(error);
    }, [
        handleError,
        onError
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: fallback,
        onError: handleOnError,
        children: children
    });
}
const $31bd555df287b548$var$useConditionalNavBoundaryContext = (0, $49YLc.functionWithFG)('navx_uc_sentry_enabled', (0, $5IDSL.useNavBoundaryContext), ()=>({
        handleError: ()=>{}
    }));
module.exports["GenericErrorBoundary"] = $31bd555df287b548$export$9e9b5b3f9c08ce57;

});

parcelRegister("jjCkw", function(module, exports) {
const $38e5614694cf6bb5$export$373682275c03fc63 = 'universal-create';
const $38e5614694cf6bb5$export$4fbca0e866deff63 = `${$38e5614694cf6bb5$export$373682275c03fc63}-trigger-button-target`;
const $38e5614694cf6bb5$export$3f4cc858c0cb6e84 = `${$38e5614694cf6bb5$export$373682275c03fc63}-trigger-button`;
const $38e5614694cf6bb5$export$85183a312807388d = 'navigation';
const $38e5614694cf6bb5$export$4e49778ae689b92a = 3;
const $38e5614694cf6bb5$export$c2ae99333adf8094 = 'universal-create';
const $38e5614694cf6bb5$export$4c7df19e787d8989 = [
    'ati:cloud:townsquare:team',
    'ati:cloud:townsquare:goal'
];
const $38e5614694cf6bb5$export$441df76988f6d01 = 344;
const $38e5614694cf6bb5$export$d268f31a83479f83 = 'sm';
const $38e5614694cf6bb5$export$aca7035f4c6a6c0b = -1;
module.exports["PACKAGE_PREFIX"] = $38e5614694cf6bb5$export$373682275c03fc63;
module.exports["TRIGGER_BUTTON_TEST_ID"] = $38e5614694cf6bb5$export$3f4cc858c0cb6e84;
module.exports["MAX_ALLOWED_SECTIONS"] = $38e5614694cf6bb5$export$4e49778ae689b92a;
module.exports["SOURCE_LOCATION"] = $38e5614694cf6bb5$export$c2ae99333adf8094;
module.exports["REQUIRED_USER_ITEMS"] = $38e5614694cf6bb5$export$4c7df19e787d8989;
module.exports["MAX_MENU_HEIGHT"] = $38e5614694cf6bb5$export$441df76988f6d01;
module.exports["RESPONSIVE_BREAKPOINT"] = $38e5614694cf6bb5$export$d268f31a83479f83;
module.exports["PRIMARY_ACTION_ITEM_INDEX"] = $38e5614694cf6bb5$export$aca7035f4c6a6c0b;

});

parcelRegister("VSkIN", function(module, exports) {
function $d27513c3e3d1447c$export$270a88864b52a4aa(items) {
    if (Array.isArray(items)) return items.every((item)=>{
        return typeof item === 'object' && item !== null && 'ati' in item;
    });
    return false;
}
function $d27513c3e3d1447c$export$badb391c957852f7(items) {
    const mixedItems = [];
    if ($d27513c3e3d1447c$export$270a88864b52a4aa(items)) mixedItems.push({
        items: items
    });
    else mixedItems.push(...items);
    return mixedItems;
}
function $d27513c3e3d1447c$export$5a8ab32aeea5694f(items, selectedItem) {
    for (const namedItem of items)for (const menuItem of namedItem.items){
        if (menuItem.ati.toString() === selectedItem.toString()) return menuItem;
    }
    return null;
}
function $d27513c3e3d1447c$export$1ed1ee46541b3e7a(sections, selectedItem) {
    for (const section of sections)// Only app-defined sections have items at definition time
    if (section.type === 'appDefinedSection') {
        for (const menuItem of section.items)// Check if item has ati property (both NativeMenuItem and CrossAppMenuItemV2 have it)
        if ('ati' in menuItem && menuItem.ati.toString() === selectedItem.toString()) {
            // For cross-app items, we need to return null as they don't have onClick/loadCreateContent
            // Only native items can be "selected" in the traditional sense
            if ('onClick' in menuItem || 'loadCreateContent' in menuItem) return menuItem;
        }
    }
    return null;
}
function $d27513c3e3d1447c$export$911e33c48adcec1b(mixedItems) {
    return mixedItems.flatMap((namedItem)=>namedItem.items).map((menuItem)=>menuItem.ati.toString());
}
module.exports["useNormalizeItems"] = $d27513c3e3d1447c$export$badb391c957852f7;
module.exports["findSelectedItem"] = $d27513c3e3d1447c$export$5a8ab32aeea5694f;
module.exports["findSelectedItemV2"] = $d27513c3e3d1447c$export$1ed1ee46541b3e7a;
module.exports["extractNativeAtis"] = $d27513c3e3d1447c$export$911e33c48adcec1b;

});

parcelRegister("arTHe", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7c773b6c8a524b1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ffCOo = parcelRequire("ffCOo");

function $d7c773b6c8a524b1$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
        data: {
            source: 'topNav'
        },
        children: children
    });
}

});

parcelRegister("3Qm0K", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

/* GicIssueCreateModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $dpPtd = parcelRequire("dpPtd");


var $cvXh8 = parcelRequire("cvXh8");


var $8tdj3 = parcelRequire("8tdj3");


var $a3fRD = parcelRequire("a3fRD");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $dh538 = parcelRequire("dh538");


var $u9agA = parcelRequire("u9agA");


var $1FnR2 = parcelRequire("1FnR2");





var $9DI9J = parcelRequire("9DI9J");


var $3ebuO = parcelRequire("3ebuO");


var $a2FWS = parcelRequire("a2FWS");

const $7daa724bead27686$var$JIRA_ITEM_PRODUCT = 'jira';
function $7daa724bead27686$export$c2b496443464407c({ product: product, subProduct: subProduct, isCrossAppCreate: isCrossAppCreate = false }) {
    const { fireObjectCreatedResult: fireObjectCreatedResult, fireFormControlAttributes: fireFormControlAttributes, fireFlagControlAttributes: fireFlagControlAttributes } = (0, $3ebuO.usePlatformCreateAnalytics)();
    const modalViewedRef = (0, $42omo.useRef)(false);
    // Fire "create modal viewed" analytics once per mount.
    (0, $42omo.useEffect)(function fireModalViewAnalytics() {
        if (!modalViewedRef.current) {
            fireFormControlAttributes({
                ...(0, $a2FWS.getBaseFormControlAnalyticsAttributes)({
                    itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
                    sourceProduct: product,
                    sourceSubProduct: subProduct
                }),
                itemProduct: $7daa724bead27686$var$JIRA_ITEM_PRODUCT,
                action: 'viewed',
                actionSubjectId: 'createModal',
                crossAppCreation: isCrossAppCreate
            });
            modalViewedRef.current = true;
        }
    }, [
        fireFormControlAttributes,
        isCrossAppCreate,
        product,
        subProduct
    ]);
    const fireCreateSuccessAnalytics = (0, $42omo.useCallback)(()=>{
        fireObjectCreatedResult({
            actionSubjectId: 'universalCreateGicCreation',
            result: 'success',
            itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
            crossAppCreation: isCrossAppCreate,
            sourceProduct: product,
            sourceSubProduct: subProduct
        });
    }, [
        fireObjectCreatedResult,
        product,
        isCrossAppCreate,
        subProduct
    ]);
    const fireCreateFailureAnalytics = (0, $42omo.useCallback)(()=>{
        fireObjectCreatedResult({
            actionSubjectId: 'universalCreateGicCreation',
            result: 'failed',
            itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
            crossAppCreation: isCrossAppCreate,
            sourceProduct: product,
            sourceSubProduct: subProduct
        });
    }, [
        fireObjectCreatedResult,
        product,
        isCrossAppCreate,
        subProduct
    ]);
    const fireModalCloseAnalytics = (0, $42omo.useCallback)(()=>{
        fireFormControlAttributes({
            ...(0, $a2FWS.getBaseFormControlAnalyticsAttributes)({
                itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
                sourceProduct: product,
                sourceSubProduct: subProduct
            }),
            action: 'dismissed',
            itemProduct: $7daa724bead27686$var$JIRA_ITEM_PRODUCT,
            actionSubjectId: 'createGicModal',
            crossAppCreation: isCrossAppCreate
        });
    }, [
        fireFormControlAttributes,
        isCrossAppCreate,
        product,
        subProduct
    ]);
    const fireGicCloseAnalytics = (0, $42omo.useCallback)((isCreateSuccess)=>{
        fireFormControlAttributes({
            ...(0, $a2FWS.getBaseFormControlAnalyticsAttributes)({
                itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
                sourceProduct: product,
                sourceSubProduct: subProduct
            }),
            action: 'dismissed',
            itemProduct: $7daa724bead27686$var$JIRA_ITEM_PRODUCT,
            actionSubjectId: 'createGicForm',
            crossAppCreation: isCrossAppCreate,
            isCreateSuccess: isCreateSuccess
        });
    }, [
        fireFormControlAttributes,
        isCrossAppCreate,
        product,
        subProduct
    ]);
    const fireOpenInJiraClickAnalytics = (0, $42omo.useCallback)(()=>{
        fireFlagControlAttributes({
            ...(0, $a2FWS.getBaseFormControlAnalyticsAttributes)({
                itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
                sourceProduct: product,
                sourceSubProduct: subProduct
            }),
            itemProduct: $7daa724bead27686$var$JIRA_ITEM_PRODUCT,
            actionSubjectId: 'createModalOpenInJiraLink',
            crossAppCreation: isCrossAppCreate,
            flagName: 'issueCreateSuccess'
        });
    }, [
        fireFlagControlAttributes,
        isCrossAppCreate,
        product,
        subProduct
    ]);
    const fireCopyLinkClickAnalytics = (0, $42omo.useCallback)(()=>{
        fireFlagControlAttributes({
            ...(0, $a2FWS.getBaseFormControlAnalyticsAttributes)({
                itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
                sourceProduct: product,
                sourceSubProduct: subProduct
            }),
            itemProduct: $7daa724bead27686$var$JIRA_ITEM_PRODUCT,
            actionSubjectId: 'createModalCopyLinkButton',
            crossAppCreation: isCrossAppCreate,
            flagName: 'issueCreateSuccess'
        });
    }, [
        fireFlagControlAttributes,
        isCrossAppCreate,
        product,
        subProduct
    ]);
    return {
        fireCreateSuccessAnalytics: fireCreateSuccessAnalytics,
        fireCreateFailureAnalytics: fireCreateFailureAnalytics,
        fireModalCloseAnalytics: fireModalCloseAnalytics,
        fireGicCloseAnalytics: fireGicCloseAnalytics,
        fireCopyLinkClickAnalytics: fireCopyLinkClickAnalytics,
        fireOpenInJiraClickAnalytics: fireOpenInJiraClickAnalytics
    };
}


const $269cc376e7d8813d$var$styles = {
    issueCreateWrapper: "_4t3i815d _1e0c11p5"
};
const $269cc376e7d8813d$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.create-title",
        defaultMessage: "Create work item"
    },
    successFlagTitle: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.success-flag-title",
        defaultMessage: "Created {issueKey}"
    },
    openInJira: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.open-in-jira",
        defaultMessage: "Open in Jira"
    },
    copyLink: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.copy-link",
        defaultMessage: "Copy link"
    },
    workItemErrorFlagTitle: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.work-item-error-flag-title",
        defaultMessage: "We couldn't create your work item"
    },
    workItemErrorFlagDescription: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.work-item-error-flag-description",
        defaultMessage: "There was an error while creating your work item. Please try again."
    },
    workItemErrorFlagDescriptionThirdPartyCookies: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.work-item-error-flag-description-third-party-cookies",
        defaultMessage: "There was an error while creating your work item. Please enable third party cookies and try again."
    }
});

const $269cc376e7d8813d$var$GicAnywhere = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("HmLCX")).then((module)=>({
            default: module.GicAnywhere
        })));
/**
 * Default configuration for GIC that hides the site picker.
 * This is used when displaySitePicker should be false as per the ticket requirement.
 */ const $269cc376e7d8813d$var$DEFAULT_GIC_CONFIGURATION = {
    displaySitePicker: false
};
function $269cc376e7d8813d$export$d9ec5138ae1be3bf({ cloudId: cloudId, consumer: consumer = 'universalCreate', product: product, subProduct: subProduct, isCrossAppCreate: isCrossAppCreate, isOpen: isOpen, onClose: onClose, onFailure: onFailure, onInit: onInit, onSuccess: onSuccess }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const flagCounterRef = (0, $42omo.useRef)(0);
    const { fireModalCloseAnalytics: fireModalCloseAnalytics, fireGicCloseAnalytics: fireGicCloseAnalytics, fireCopyLinkClickAnalytics: fireCopyLinkClickAnalytics, fireCreateSuccessAnalytics: fireCreateSuccessAnalytics, fireCreateFailureAnalytics: fireCreateFailureAnalytics, fireOpenInJiraClickAnalytics: fireOpenInJiraClickAnalytics } = (0, $7daa724bead27686$export$c2b496443464407c)({
        product: product,
        subProduct: subProduct,
        isCrossAppCreate: isCrossAppCreate
    });
    const showSuccessFlag = (0, $42omo.useCallback)((payload)=>{
        showFlag({
            id: `gic-issue-create-success-${flagCounterRef.current += 1}`,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "",
                spacing: "spacious"
            }),
            title: formatMessage($269cc376e7d8813d$var$messages.successFlagTitle, {
                issueKey: payload.issueKey
            }),
            isAutoDismiss: true,
            actions: [
                {
                    content: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            formatMessage($269cc376e7d8813d$var$messages.openInJira),
                            ' ',
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                                label: "",
                                color: "currentColor"
                            })
                        ]
                    }),
                    href: payload.link,
                    onClick: ()=>{
                        fireOpenInJiraClickAnalytics();
                    }
                },
                ...!(0, $dh538.fg)('navx_uc_remove_copy_link_from_flag') ? [
                    {
                        content: formatMessage($269cc376e7d8813d$var$messages.copyLink),
                        onClick: ()=>{
                            fireCopyLinkClickAnalytics();
                            navigator.clipboard.writeText(payload.link).catch(()=>{});
                        }
                    }
                ] : []
            ]
        });
    }, [
        showFlag,
        formatMessage,
        fireCopyLinkClickAnalytics,
        fireOpenInJiraClickAnalytics
    ]);
    const handleGicInit = (0, $42omo.useCallback)(()=>{
        onInit?.();
    }, [
        onInit
    ]);
    const handleModalClose = (0, $42omo.useCallback)(()=>{
        fireModalCloseAnalytics();
        onClose?.();
    }, [
        fireModalCloseAnalytics,
        onClose
    ]);
    const handleGicClose = (0, $42omo.useCallback)((isCreateSuccess)=>{
        fireGicCloseAnalytics(isCreateSuccess);
        onClose?.(isCreateSuccess);
    }, [
        fireGicCloseAnalytics,
        onClose
    ]);
    const handleGicSuccess = (0, $42omo.useCallback)((payload)=>{
        fireCreateSuccessAnalytics();
        showSuccessFlag(payload);
        onSuccess?.(payload);
    }, [
        fireCreateSuccessAnalytics,
        onSuccess,
        showSuccessFlag
    ]);
    const handleGicFailure = (0, $42omo.useCallback)((error)=>{
        showFlag({
            id: `gic-issue-create-error-${flagCounterRef.current += 1}`,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            title: formatMessage($269cc376e7d8813d$var$messages.workItemErrorFlagTitle),
            description: formatMessage($269cc376e7d8813d$var$messages.workItemErrorFlagDescription),
            isAutoDismiss: true
        });
        fireCreateFailureAnalytics();
        onFailure?.(error);
    }, [
        onFailure,
        showFlag,
        formatMessage,
        fireCreateFailureAnalytics
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
            onClose: ()=>handleModalClose(),
            width: "large",
            shouldScrollInViewport: true,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        children: formatMessage($269cc376e7d8813d$var$messages.title)
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $269cc376e7d8813d$var$styles.issueCreateWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $l998X.jsx)($269cc376e7d8813d$var$GicAnywhere, {
                                cloudId: cloudId,
                                consumer: consumer,
                                summary: "",
                                configuration: $269cc376e7d8813d$var$DEFAULT_GIC_CONFIGURATION,
                                onInit: handleGicInit,
                                onClose: handleGicClose,
                                onSuccess: handleGicSuccess,
                                onFailure: handleGicFailure,
                                isPayloadReady: true
                            })
                        })
                    })
                })
            ]
        })
    });
}
function $269cc376e7d8813d$export$add83b67a410a424(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1FnR2.AsyncIntlProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($269cc376e7d8813d$export$d9ec5138ae1be3bf, {
                ...props
            })
        })
    });
}



var $19BZl = parcelRequire("19BZl");

const $45e2cc33455f22a7$var$GicModalContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $45e2cc33455f22a7$export$212673996097ff74 = ()=>{
    const context = (0, $42omo.useContext)($45e2cc33455f22a7$var$GicModalContext);
    if (context === null) throw new Error('useGicModal must be used within a GicModalProvider');
    return context;
};
const $45e2cc33455f22a7$export$3dc00ad9a457ac24 = ({ children: children })=>{
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const { crossAppCreationConfig: crossAppCreationConfig, product: product, subProduct: subProduct } = (0, $19BZl.useUniversalCreateState)();
    const cloudId = crossAppCreationConfig.enabled ? crossAppCreationConfig.cloudId : null;
    const openGicModal = (0, $42omo.useCallback)(()=>{
        setIsModalOpen(true);
    }, []);
    const handleCloseGicModal = (0, $42omo.useCallback)(()=>{
        setIsModalOpen(false);
    }, []);
    const contextValue = (0, $42omo.useMemo)(()=>({
            openGicModal: openGicModal
        }), [
        openGicModal
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)($45e2cc33455f22a7$var$GicModalContext.Provider, {
        value: contextValue,
        children: [
            children,
            cloudId && /*#__PURE__*/ (0, $l998X.jsx)((0, $269cc376e7d8813d$export$add83b67a410a424), {
                cloudId: cloudId,
                product: product,
                subProduct: subProduct,
                // This should always be true in cross-app creation flow
                isCrossAppCreate: true,
                isOpen: isModalOpen,
                onClose: handleCloseGicModal
            })
        ]
    });
};
module.exports["useGicModal"] = $45e2cc33455f22a7$export$212673996097ff74;
module.exports["GicModalProvider"] = $45e2cc33455f22a7$export$3dc00ad9a457ac24;

});

parcelRegister("1FnR2", function(module, exports) {
/* AsyncIntlProvider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $keVvA = parcelRequire("keVvA");


var $kWIfM = parcelRequire("kWIfM");

function $facd1d381551dc6d$export$bca6b946a784e234(locale) {
    if ([
        'en-GB',
        'en-ZZ',
        'pt-PT',
        'zh-TW'
    ].includes(locale)) return locale;
    else if (locale === 'zh-HK') return 'zh-TW';
    return locale.split('-')[0];
}

























function $facd1d381551dc6d$var$fetchLanguageFile(code) {
    switch(code){
        case 'cs':
            return (parcelRequire("gOCKa"));
        case 'da':
            return (parcelRequire("kgS6g"));
        case 'de':
            return (parcelRequire("6FETJ"));
        case 'en-GB':
            return (parcelRequire("eaG2w"));
        case 'en-ZZ':
            return (parcelRequire("jrncK"));
        case 'en':
            return Promise.resolve((parcelRequire("kWIfM")));
        case 'es':
            return (parcelRequire("hNXtP"));
        case 'fi':
            return (parcelRequire("jpKHe"));
        case 'fr':
            return (parcelRequire("egD3h"));
        case 'hu':
            return (parcelRequire("gOBa4"));
        case 'it':
            return (parcelRequire("dJGOW"));
        case 'ja':
            return (parcelRequire("91ceq"));
        case 'ko':
            return (parcelRequire("9BUn1"));
        case 'nb':
            return (parcelRequire("kDan3"));
        case 'nl':
            return (parcelRequire("hlN3p"));
        case 'pl':
            return (parcelRequire("cgC9O"));
        case 'pt':
            return (parcelRequire("caMGq"));
        case 'ru':
            return (parcelRequire("iH1Iu"));
        case 'sv':
            return (parcelRequire("anJkS"));
        case 'th':
            return (parcelRequire("22khn"));
        case 'tr':
            return (parcelRequire("4vKIR"));
        case 'uk':
            return (parcelRequire("hwfR8"));
        case 'vi':
            return (parcelRequire("2drle"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("7iRlg"));
        case 'zh':
            return (parcelRequire("efWdi"));
        default:
            throw new Error(`Unable to find translation for locale ${code}`);
    }
}
const $facd1d381551dc6d$export$12346a674644c156 = 'operational';
const $facd1d381551dc6d$export$515664faa1398f37 = 'navigation';
function $facd1d381551dc6d$var$Provider({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const loaderFn = async (locale)=>{
        const intlLocale = new Intl.Locale(locale.replace('_', '-'));
        try {
            const module = await $facd1d381551dc6d$var$fetchLanguageFile($facd1d381551dc6d$export$bca6b946a784e234(intlLocale.toString()));
            return module.default;
        } catch (e) {
            createAnalyticsEvent({
                eventType: $facd1d381551dc6d$export$12346a674644c156,
                action: 'not_loaded',
                actionSubject: 'uc_i18n',
                attributes: {
                    locale: locale
                }
            }).fire($facd1d381551dc6d$export$515664faa1398f37);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        loaderFn: loaderFn,
        defaultMessages: (0, $kWIfM.default),
        children: children
    });
}
const $facd1d381551dc6d$export$2f688dfcc031530a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($facd1d381551dc6d$var$Provider, {
        children: children
    });
};
module.exports["AsyncIntlProvider"] = $facd1d381551dc6d$export$2f688dfcc031530a;

});

parcelRegister("kWIfM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $165b45057ff7d0ba$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $165b45057ff7d0ba$export$2e2bcd8739ae039 = {
    'platform.navigation-experiences.universal-create-integrations.back': 'Back',
    'platform.navigation-experiences.universal-create-integrations.goal.create-title': 'Create goal',
    'platform.navigation-experiences.universal-create-integrations.goal.create-title-v2': 'Goal',
    'platform.navigation-experiences.universal-create-integrations.issue.copy-link': 'Copy link',
    'platform.navigation-experiences.universal-create-integrations.issue.create-title': 'Create work item',
    'platform.navigation-experiences.universal-create-integrations.issue.open-in-jira': 'Open in Jira',
    'platform.navigation-experiences.universal-create-integrations.issue.success-flag-title': 'Created {issueKey}',
    'platform.navigation-experiences.universal-create-integrations.issue.work-item-error-flag-description': 'There was an error while creating your work item. Please try again.',
    'platform.navigation-experiences.universal-create-integrations.issue.work-item-error-flag-title': "We couldn't create your work item",
    'platform.navigation-experiences.universal-create-integrations.project.create-title': 'Create project',
    'platform.navigation-experiences.universal-create-integrations.project.create-title-v2': 'Project',
    'platform.navigation-experiences.universal-create-integrations.required-fields-are-marked': 'Required fields are marked with an asterisk <asterisk></asterisk>',
    'platform.navigation-experiences.universal-create-integrations.team.create-title': 'Create team',
    'platform.navigation-experiences.universal-create-integrations.team.create-title-v2': 'Team',
    'universal-create.loom-video-menu-item.share-video': 'Share'
};

});

parcelRegister("gOCKa", function(module, exports) {

let $c3df5e8bf0b44a81$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3df5e8bf0b44a81$var$load("4XOEX").then(()=>parcelRequire('g3tQg'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("kgS6g", function(module, exports) {

let $ec1f44643886dc6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec1f44643886dc6b$var$load("gqmha").then(()=>parcelRequire('hCifW'));

});

parcelRegister("6FETJ", function(module, exports) {

let $4db64bdd29215e0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4db64bdd29215e0e$var$load("cweX3").then(()=>parcelRequire('cKDAe'));

});

parcelRegister("eaG2w", function(module, exports) {

let $a5129c10588fe984$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5129c10588fe984$var$load("bai9u").then(()=>parcelRequire('ksQ21'));

});

parcelRegister("jrncK", function(module, exports) {

let $e27289df456bec13$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e27289df456bec13$var$load("9t1Ib").then(()=>parcelRequire('8Fif4'));

});

parcelRegister("hNXtP", function(module, exports) {

let $cf6526c4d6070545$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cf6526c4d6070545$var$load("eHlQ9").then(()=>parcelRequire('6RKnN'));

});

parcelRegister("jpKHe", function(module, exports) {

let $e224930389ece4a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e224930389ece4a9$var$load("6abco").then(()=>parcelRequire('jBm4D'));

});

parcelRegister("egD3h", function(module, exports) {

let $a630da343b6d6b23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a630da343b6d6b23$var$load("fvLDA").then(()=>parcelRequire('fclNH'));

});

parcelRegister("gOBa4", function(module, exports) {

let $c3de2459ee3a56b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3de2459ee3a56b8$var$load("jYjnT").then(()=>parcelRequire('7iOJp'));

});

parcelRegister("dJGOW", function(module, exports) {

let $a000b1a177f404f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a000b1a177f404f7$var$load("6chG6").then(()=>parcelRequire('4o46R'));

});

parcelRegister("91ceq", function(module, exports) {

let $690db206d079dded$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $690db206d079dded$var$load("bXBzb").then(()=>parcelRequire('82cDt'));

});

parcelRegister("9BUn1", function(module, exports) {

let $6ff34bb529d22ed2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ff34bb529d22ed2$var$load("fMgo4").then(()=>parcelRequire('57xzB'));

});

parcelRegister("kDan3", function(module, exports) {

let $f04f7e974ea5a306$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f04f7e974ea5a306$var$load("1HBhy").then(()=>parcelRequire('jMKyM'));

});

parcelRegister("hlN3p", function(module, exports) {

let $ca1a72efc40ba994$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca1a72efc40ba994$var$load("9YSn1").then(()=>parcelRequire('7pHxv'));

});

parcelRegister("cgC9O", function(module, exports) {

let $8ee493df0ce89edf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ee493df0ce89edf$var$load("40Jja").then(()=>parcelRequire('bEas4'));

});

parcelRegister("caMGq", function(module, exports) {

let $8dcc2ead7a022171$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8dcc2ead7a022171$var$load("ibJOL").then(()=>parcelRequire('ltVvr'));

});

parcelRegister("iH1Iu", function(module, exports) {

let $d9bd930c52a36b5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d9bd930c52a36b5a$var$load("ipGTo").then(()=>parcelRequire('eYQSf'));

});

parcelRegister("anJkS", function(module, exports) {

let $78ef381d406ade9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78ef381d406ade9e$var$load("1dEiK").then(()=>parcelRequire('lioXF'));

});

parcelRegister("22khn", function(module, exports) {

let $17bb7fba3f76370b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17bb7fba3f76370b$var$load("bNIzh").then(()=>parcelRequire('jypAP'));

});

parcelRegister("4vKIR", function(module, exports) {

let $348e4cc97734f269$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $348e4cc97734f269$var$load("bjl5Z").then(()=>parcelRequire('jVD7j'));

});

parcelRegister("hwfR8", function(module, exports) {

let $cc11b97e6ec0b207$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc11b97e6ec0b207$var$load("7A6MW").then(()=>parcelRequire('asGOa'));

});

parcelRegister("2drle", function(module, exports) {

let $19d2011add1ec057$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19d2011add1ec057$var$load("gu0nB").then(()=>parcelRequire('d0iu1'));

});

parcelRegister("7iRlg", function(module, exports) {

let $5513977223045f44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5513977223045f44$var$load("2xhtF").then(()=>parcelRequire('hTwBU'));

});

parcelRegister("efWdi", function(module, exports) {

let $a60f9f61761fae66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a60f9f61761fae66$var$load("iwPoV").then(()=>parcelRequire('8yoE1'));

});

parcelRegister("9DI9J", function(module, exports) {
const $7387c4ee4c968c68$export$85183a312807388d = 'navigation';
const $7387c4ee4c968c68$export$1f0ede2864ffece6 = 'navigationExperiences';
const $7387c4ee4c968c68$export$40fae459cb78b698 = 'global';
const $7387c4ee4c968c68$export$2ee98aa1b18a8f41 = 'top';
const $7387c4ee4c968c68$export$b4ed8a331b8fd4cc = 4;
const $7387c4ee4c968c68$export$f7109619a5e9e0d6 = 'topNav';
const $7387c4ee4c968c68$export$c091fab9d8f83000 = {
    PAGE: 'ati:cloud:confluence:page',
    WHITEBOARD: 'ati:cloud:confluence:whiteboard',
    GOAL: 'ati:cloud:townsquare:goal',
    WORK_ITEM: 'ati:cloud:jira:issue',
    LOOM: 'ati:cloud:loom:video',
    PROJECT: 'ati:cloud:townsquare:project',
    TEAM: 'ati:cloud:townsquare:team',
    TRELLO_BOARD: 'ati:cloud:trello:board'
};
const $7387c4ee4c968c68$export$9449803ae25a1ccd = $7387c4ee4c968c68$export$c091fab9d8f83000.LOOM;
module.exports["ANALYTICS_CHANNEL"] = $7387c4ee4c968c68$export$85183a312807388d;
module.exports["ANALYTICS_TAG"] = $7387c4ee4c968c68$export$1f0ede2864ffece6;
module.exports["NAV_LAYER"] = $7387c4ee4c968c68$export$40fae459cb78b698;
module.exports["NAV_CONTAINER"] = $7387c4ee4c968c68$export$2ee98aa1b18a8f41;
module.exports["NAV_VERSION"] = $7387c4ee4c968c68$export$b4ed8a331b8fd4cc;
module.exports["ANALYTICS_SOURCE"] = $7387c4ee4c968c68$export$f7109619a5e9e0d6;
module.exports["ATI_PRESETS"] = $7387c4ee4c968c68$export$c091fab9d8f83000;
module.exports["LOOM_ATI"] = $7387c4ee4c968c68$export$9449803ae25a1ccd;

});

parcelRegister("3ebuO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9DI9J = parcelRequire("9DI9J");

function $f9f6c5a9f12e5699$export$5119f9387406ce5a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const baseAttributes = (0, $42omo.useMemo)(()=>({
            navLayer: (0, $9DI9J.NAV_LAYER),
            navContainer: (0, $9DI9J.NAV_CONTAINER),
            navVersion: (0, $9DI9J.NAV_VERSION)
        }), []);
    const topLevelAttributes = (0, $42omo.useMemo)(()=>({
            actionSubject: 'universalCreate',
            eventType: 'operational',
            source: (0, $9DI9J.ANALYTICS_SOURCE),
            tags: [
                (0, $9DI9J.ANALYTICS_TAG)
            ]
        }), []);
    const fireObjectCreated = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'created',
            actionSubjectId: 'universalCreateObject',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireObjectCreatedResult = (0, $42omo.useCallback)(({ actionSubjectId: actionSubjectId, result: result, ...attributes })=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: 'track',
            action: result,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // createModal viewed Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90539
    // createModalBackButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90540
    // createModalCancelButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90541
    // createModalCreateButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90542
    const fireFormControlAttributes = (0, $42omo.useCallback)(({ actionSubjectId: actionSubjectId, action: action = 'clicked', ...attributes })=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: 'ui',
            actionSubject: 'universalCreate',
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireFlagControlAttributes = (0, $42omo.useCallback)(({ actionSubjectId: actionSubjectId, ...attributes })=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: 'ui',
            actionSubject: 'universalCreate',
            action: 'clicked',
            actionSubjectId: actionSubjectId,
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    return {
        fireFlagControlAttributes: fireFlagControlAttributes,
        fireObjectCreated: fireObjectCreated,
        fireObjectCreatedResult: fireObjectCreatedResult,
        fireFormControlAttributes: fireFormControlAttributes
    };
}
module.exports["usePlatformCreateAnalytics"] = $f9f6c5a9f12e5699$export$5119f9387406ce5a;

});

parcelRegister("a2FWS", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $37390df0788634a5$export$242c779274b0e3bf = ({ itemAti: itemAti, sourceProduct: sourceProduct, sourceSubProduct: sourceSubProduct })=>({
        itemAti: itemAti,
        itemProduct: 'townsquare',
        ...(0, $dh538.fg)('navx-3019-uc-form-events-analytics-subproduct') ? {
            sourceProduct: sourceProduct,
            sourceSubProduct: sourceSubProduct
        } : {}
    });
module.exports["getBaseFormControlAnalyticsAttributes"] = $37390df0788634a5$export$242c779274b0e3bf;

});

parcelRegister("HmLCX", function(module, exports) {

let $0825ad5afca5138a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0825ad5afca5138a$var$load("cUIaj"),
    $0825ad5afca5138a$var$load("8ee3Z"),
    $0825ad5afca5138a$var$load("fleTp"),
    $0825ad5afca5138a$var$load("2O2Xv"),
    $0825ad5afca5138a$var$load("Wowvf"),
    $0825ad5afca5138a$var$load("d34hg")
]).then(()=>parcelRequire('6aRpj'));

});

parcelRegister("7K3dX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9DI9J = parcelRequire("9DI9J");


var $19BZl = parcelRequire("19BZl");

function $c3ddb99f3c87e2eb$export$eebe354ebe67c94c() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { product: product, subProduct: subProduct } = (0, $19BZl.useUniversalCreateState)();
    // Provide fallback for product if undefined
    const safeProduct = product || 'unknown';
    const baseAttributes = (0, $42omo.useMemo)(()=>({
            navLayer: (0, $9DI9J.NAV_LAYER),
            navContainer: (0, $9DI9J.NAV_CONTAINER),
            navVersion: (0, $9DI9J.NAV_VERSION),
            product: safeProduct,
            subProduct: subProduct
        }), [
        safeProduct,
        subProduct
    ]);
    const topLevelAttributes = (0, $42omo.useMemo)(()=>({
            actionSubject: 'universalCreate',
            eventType: 'ui',
            source: (0, $9DI9J.ANALYTICS_SOURCE),
            tags: [
                (0, $9DI9J.ANALYTICS_TAG)
            ]
        }), []);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88038
    const fireCreateButtonClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireCreateButtonViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireCreateButtonHovered = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'hovered',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireEntryPointLoadTriggered = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            actionSubject: 'universalCreateEntryPointLoad',
            action: 'triggered',
            eventType: 'track',
            source: (0, $9DI9J.ANALYTICS_SOURCE),
            tags: [
                (0, $9DI9J.ANALYTICS_TAG)
            ],
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88332
    const fireNativeMenuItemClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateNativeMenuItem',
            attributes: {
                group: 'native',
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88486
    const fireSuggestionsMenuItemClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateSuggestionsMenuItem',
            attributes: {
                group: 'suggestions',
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88295
    const fireMenuItemClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateMenuItem',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88599
    const fireNativeMenuViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateNativeMenu',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88724
    const fireSuggestionsMenuViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateSuggestionsMenu',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92169
    const fireMenuItemsViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateMenuSection',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/89698
    const fireMenuStateChanged = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'changed',
            actionSubjectId: 'universalCreateMenuState',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        baseAttributes
    ]);
    // createModal viewed Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90539
    // createModalBackButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90540
    // createModalCancelButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90541
    // createModalCreateButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90542
    const fireFormControlAttributes = (0, $42omo.useCallback)(({ actionSubjectId: actionSubjectId, action: action = 'clicked', ...attributes })=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            actionSubject: 'universalCreate',
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92730
    const fireShowMoreButtonClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateShowMoreButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/96626
    const fireJSChunkLoadTime = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'loaded',
            actionSubject: 'universalCreateJSChunkLoad',
            actionSubjectId: 'universalCreateJSChunkLoad',
            eventType: 'operational',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    return {
        fireCreateButtonClicked: fireCreateButtonClicked,
        fireCreateButtonHovered: fireCreateButtonHovered,
        fireCreateButtonViewed: fireCreateButtonViewed,
        fireEntryPointLoadTriggered: fireEntryPointLoadTriggered,
        fireNativeMenuItemClicked: fireNativeMenuItemClicked,
        fireSuggestionsMenuItemClicked: fireSuggestionsMenuItemClicked,
        fireMenuItemClicked: fireMenuItemClicked,
        fireNativeMenuViewed: fireNativeMenuViewed,
        fireSuggestionsMenuViewed: fireSuggestionsMenuViewed,
        fireMenuItemsViewed: fireMenuItemsViewed,
        fireMenuStateChanged: fireMenuStateChanged,
        fireFormControlAttributes: fireFormControlAttributes,
        fireShowMoreButtonClicked: fireShowMoreButtonClicked,
        fireJSChunkLoadTime: fireJSChunkLoadTime
    };
}
module.exports["useUniversalCreateAnalytics"] = $c3ddb99f3c87e2eb$export$eebe354ebe67c94c;

});

parcelRegister("fP8Uu", function(module, exports) {
// ===============================
// UC Suggestions API Communication types
// ===============================

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $ekTM6 = parcelRequire("ekTM6");

var $5IDSL = parcelRequire("5IDSL");


var $l7sDu = parcelRequire("l7sDu");


var $4jETc = parcelRequire("4jETc");


var $caUKj = parcelRequire("caUKj");


var $6lFYf = parcelRequire("6lFYf");


var $dG1kO = parcelRequire("dG1kO");


var $ik19A = parcelRequire("ik19A");


var $cdX3N = parcelRequire("cdX3N");

function $fa4ca6a68a7d4b0f$export$b0f8ffa1c91c3ff2({ cloudId: cloudId, orgId: orgId, product: product, userId: userId, locale: locale, subProduct: subProduct, nativeAtis: nativeAtis, excludeAtis: excludeAtis, preferredAtis: preferredAtis }) {
    const { value: value, currentLoadingRequests: currentLoadingRequests } = (0, $caUKj.useBFFContext)();
    const boundaryConfig = (0, $42omo.useMemo)(()=>({
            location: 'useUCSuggestions',
            disableSentry: (0, $dh538.fg)('navx_uc_sentry_enabled') ? false : true,
            disableAnalytics: true,
            sentryConfig: {
                product: product
            },
            interactionId: 'universalCreatePrefetch',
            tags: {
                component: 'universal-create',
                subProduct: subProduct
            }
        }), [
        product,
        subProduct
    ]);
    const { handleError: handleError } = (0, $5IDSL.useNavBoundaryContext)(boundaryConfig);
    const { setStatus: setStatus } = (0, $ik19A.useStatus)();
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const { buildUCRecommendationURL: buildUCRecommendationURL } = (0, $cdX3N.useURLBuilder)({
        cloudId: cloudId
    });
    const { cachedObject: cachedObject, setCachedObject: setCachedObject } = (0, $dG1kO.useGenericCache)({
        cloudId: cloudId,
        productType: product,
        orgId: orgId,
        accountId: userId,
        subProduct: subProduct,
        locale: locale,
        nativeAtis: nativeAtis,
        excludeAtis: excludeAtis,
        preferredAtis: preferredAtis
    });
    const requestIdRef = (0, $42omo.useRef)(0);
    // We need to set the data from the cache on mount (if applicable)
    // because setting it as the initial state value causes it to
    // return undefined in component usages and not be fetched from the network when expected
    if (cachedObject && !data) {
        setData(cachedObject);
        setHasError(false);
    }
    const fetchUCSuggestions = (0, $42omo.useCallback)(async ()=>{
        // Kill switch: return early if feature flag is disabled
        if (!(0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled')) return;
        // Early exit: filter out invalid param requests when required identifiers are missing
        if (!cloudId || !orgId) return;
        // Return cached data if available (already locale-scoped via cache key)
        if (cachedObject) {
            setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
            return cachedObject;
        }
        // Increment request id for race protection
        requestIdRef.current += 1;
        const scopedId = requestIdRef.current;
        // Create and start experience tracker only when actually making request
        const experience = (0, $dh538.fg)('navx-2747-ufo-prefetch-tracking') ? (0, $l7sDu.createExperienceTracker)('universalCreatePrefetch') : null;
        experience?.start();
        try {
            const url = buildUCRecommendationURL({
                product: product,
                orgId: orgId,
                userId: userId,
                locale: locale,
                subProduct: subProduct,
                nativeAtis: nativeAtis,
                excludeAtis: excludeAtis,
                preferredAtis: preferredAtis
            });
            setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
            const response = await (0, $6lFYf.fetchJSON)(url, {});
            // Ignore if this response is for a stale request
            if (scopedId !== requestIdRef.current) return;
            if (response.status === (0, $4jETc.RequestStatus).ERROR) {
                experience?.failure();
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
                if ((0, $dh538.fg)('navx_uc_sentry_enabled')) handleError(new (0, $ekTM6.BFFNetworkError)('Failed to fetch universal create suggestions', {
                    url: url,
                    status: response.status,
                    originalError: response.error
                }));
                return;
            }
            if (response.status === (0, $4jETc.RequestStatus).COMPLETE && response.data) {
                experience?.success();
                setData(response.data);
                setHasError(false);
                // Only cache if the data is not partial
                if (!response.data.isPartial) setCachedObject(response.data);
                setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
                return response.data;
            }
        } catch (error) {
            experience?.failure();
            if (scopedId === requestIdRef.current) {
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
            }
            if ((0, $dh538.fg)('navx_uc_sentry_enabled')) handleError(new (0, $ekTM6.BFFError)('Error occurred during fetchUCSuggestions', {
                status: (0, $4jETc.RequestStatus).ERROR,
                originalError: error
            }));
        }
        return;
    }, [
        cloudId,
        orgId,
        cachedObject,
        setStatus,
        buildUCRecommendationURL,
        product,
        userId,
        locale,
        subProduct,
        nativeAtis,
        excludeAtis,
        preferredAtis,
        handleError,
        setCachedObject
    ]);
    const isLoading = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled')) {
            // We check if the current loading requests include UC suggestions rather than the BFF status directly
            // to ensure that it only returns true for UC suggestions and not other BFF requests.
            const isBffLoadingOurStuff = currentLoadingRequests?.includes((0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY)) ?? false;
            // That said, if the BFF is in loading state but data has been returned, we want to wait for things to complete
            // before running things like onResultChange, so that we don't do those things an unnecessary extra time
            // during the brief moment when data is present but loading is still true, or an error has occurred and loading is still true.
            const hasSuggestionDataBeenReturned = data !== undefined || hasError;
            return isBffLoadingOurStuff && !hasSuggestionDataBeenReturned;
        }
        return currentLoadingRequests?.includes((0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY)) ?? false;
    }, [
        currentLoadingRequests,
        data,
        hasError
    ]);
    return {
        data: data,
        isLoading: isLoading,
        hasError: hasError,
        status: value.status,
        fetchUCSuggestions: fetchUCSuggestions
    };
}
module.exports["useUCSuggestions"] = $fa4ca6a68a7d4b0f$export$b0f8ffa1c91c3ff2;

});

parcelRegister("fMjA6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $19BZl = parcelRequire("19BZl");

function $060ce356f1549e47$export$a0e86d06727a8039(atiType) {
    // Access the Universal Create state
    const { suggestionConfig: suggestionConfig } = (0, $19BZl.useUniversalCreateState)();
    // Determine ATIs to pass to the hook
    const atis = (0, $42omo.useMemo)(()=>{
        if (!suggestionConfig.enabled) return undefined;
        const atiArray = atiType === 'preferred' ? suggestionConfig.preferredAtis : suggestionConfig.excludeAtis;
        if (!atiArray) return undefined;
        // Convert Ati[] to string[]
        if (Array.isArray(atiArray) && atiArray.length > 0) return atiArray.map((ati)=>ati.toString());
        // Default fallback
        return undefined;
    }, [
        suggestionConfig,
        atiType
    ]);
    return atis;
}
function $060ce356f1549e47$export$4984a78a2f2592cd() {
    return $060ce356f1549e47$export$a0e86d06727a8039('preferred');
}
function $060ce356f1549e47$export$d6dcc91285361556() {
    return $060ce356f1549e47$export$a0e86d06727a8039('exclude');
}
module.exports["useSuggestionPreferredAtis"] = $060ce356f1549e47$export$4984a78a2f2592cd;
module.exports["useSuggestionExcludeAtis"] = $060ce356f1549e47$export$d6dcc91285361556;

});

parcelRegister("6OnN8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $19BZl = parcelRequire("19BZl");


var $VSkIN = parcelRequire("VSkIN");

function $bdcbf50357937847$export$ace2aad66e79cd4e() {
    // Access the Universal Create state
    const { suggestionConfig: suggestionConfig, items: items } = (0, $19BZl.useUniversalCreateState)();
    // Determine native ATIs to pass to the hook
    const nativeAtis = (0, $42omo.useMemo)(()=>{
        if (!suggestionConfig.enabled || !suggestionConfig.nativeAtis) return undefined;
        // If nativeAtis is 'auto', extract ATIs from native menu items
        if (suggestionConfig.nativeAtis === 'auto') return (0, $VSkIN.extractNativeAtis)(items);
        // If nativeAtis is manually defined as Ati[], convert to strings and use it
        if (Array.isArray(suggestionConfig.nativeAtis) && suggestionConfig.nativeAtis.length > 0) return suggestionConfig.nativeAtis.map((ati)=>ati.toString());
        // Default fallback
        return undefined;
    }, [
        suggestionConfig,
        items
    ]);
    return nativeAtis;
}
module.exports["useSuggestionNativeAtis"] = $bdcbf50357937847$export$ace2aad66e79cd4e;

});

parcelRegister("dv953", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $41db8bac43dc4cde$export$61de563e38fe014d() {
    const fetchUser = (0, $42omo.useCallback)(async ()=>{
        try {
            const response = await fetch('/gateway/api/me', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) return undefined;
            const userData = await response.json();
            return userData;
        } catch (err) {
            return undefined;
        }
    }, []);
    return {
        fetchUser: fetchUser
    };
}
module.exports["useFetchUser"] = $41db8bac43dc4cde$export$61de563e38fe014d;

});

parcelRegister("a1Oiu", function(module, exports) {
// ===============================
// UC Menu Items V2 API Communication
// ===============================

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $ekTM6 = parcelRequire("ekTM6");

var $5IDSL = parcelRequire("5IDSL");


var $l7sDu = parcelRequire("l7sDu");

/**
 * Encode configuration to binary format with query parameters
 */ /**
 * Encode ATI string to binary representation
 */ /**
 * Utility functions for parsing and constructing ATI strings
 * Uses @atlassian/ari package for ATI parsing
 */ 
var $6yCpa = parcelRequire("6yCpa");

function $0bf79e81331e4541$export$5597e67f4dded1e6(ati) {
    try {
        const parsed = (0, $6yCpa.Ati).parse(ati);
        return {
            prefix: parsed.platformQualifier,
            owner: parsed.resourceOwner,
            type: parsed.resourceType
        };
    } catch  {
        throw new Error(`Invalid ATI format: expected "ati:<prefix>:<owner>:<type>", got "${ati}"`);
    }
}
function $0bf79e81331e4541$export$9acdaf42ad16ae47({ prefix: prefix, owner: owner, type: type }) {
    if (!prefix || !owner || !type) throw new Error('All ATI components (prefix, owner, type) must be non-empty');
    try {
        const ati = (0, $6yCpa.Ati).create({
            platformQualifier: prefix,
            resourceOwner: owner,
            resourceType: type
        });
        return ati.toString();
    } catch  {
        throw new Error('Failed to construct ATI from components');
    }
}
function $0bf79e81331e4541$export$9039e3b1770c6b8(ati) {
    if (typeof ati !== 'string') return false;
    try {
        (0, $6yCpa.Ati).parse(ati);
        return true;
    } catch  {
        return false;
    }
}
function $0bf79e81331e4541$export$912bb685303c4ec7(items) {
    return Object.fromEntries(items.map((item, index)=>[
            item,
            index
        ]));
}


/**
 * Binary Encoding Constants for Universal Create Menu (V2 API)
 *
 * This module defines the constants used for encoding/decoding ATI configurations
 * into a compact binary format for URL transmission.
 *
 * These constants are shared across frontend and backend for binary encoding/decoding operations.
 */ 
const $dccf36f4b2146e6b$export$3167453beff01750 = 2;
const $dccf36f4b2146e6b$export$b2144c689c2ff042 = [
    'cloud',
    'third-party'
];
const $dccf36f4b2146e6b$export$61beacecbf214ae6 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$b2144c689c2ff042);
const $dccf36f4b2146e6b$export$89e1a37ecee09500 = [
    // ALL NEW RESOURCE OWNERS MUST BE ADDED AT THE END OF THIS LIST
    'jira',
    'confluence',
    'loom',
    'townsquare',
    'trello',
    'bitbucket',
    'opsgenie',
    'compass',
    'statuspage',
    'atlas'
];
const $dccf36f4b2146e6b$export$83dfff18be6bef06 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$89e1a37ecee09500);
const $dccf36f4b2146e6b$export$9dd62a2b56d5462d = [
    // ALL NEW RESOURCE TYPES MUST BE ADDED AT THE END OF THIS LIST
    'issue',
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'space',
    'video',
    'goal',
    'project',
    'team',
    'post',
    'board',
    'repository',
    'workspace',
    'component',
    'embed',
    'livedoc',
    'chat',
    'agent'
];
const $dccf36f4b2146e6b$export$38830b2321100ef2 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$9dd62a2b56d5462d);
const $dccf36f4b2146e6b$export$b1e8f8dc54861a99 = 3;
const $dccf36f4b2146e6b$export$21d9e5eeb6ffaecd = 1;
const $dccf36f4b2146e6b$export$19409b356a31bc6d = {
    // Byte 0 masks
    PREFIX_FLAG_MASK: 128,
    OWNER_FLAG_MASK: 64,
    TYPE_FLAG_MASK: 32,
    PREFIX_VALUE_MASK: 16,
    OWNER_UPPER_MASK: 15,
    // Byte 1 masks
    OWNER_LOWER_MASK: 240,
    TYPE_UPPER_MASK: 15,
    // Byte 2 masks
    TYPE_LOWER_MASK: 255
};
const $dccf36f4b2146e6b$export$4c68bfc8c9124205 = {
    PREFIX_FLAG_SHIFT: 7,
    OWNER_FLAG_SHIFT: 6,
    TYPE_FLAG_SHIFT: 5,
    PREFIX_VALUE_SHIFT: 4,
    OWNER_LOWER_SHIFT: 4,
    OWNER_UPPER_BITS: 4,
    TYPE_UPPER_SHIFT: 4,
    TYPE_UPPER_BITS: 8
};
const $dccf36f4b2146e6b$export$597234ac346c7ad8 = 256;
const $dccf36f4b2146e6b$export$8c22d9b338278eca = 4096;
const $dccf36f4b2146e6b$export$3010378ceda42048 = 256;
const $dccf36f4b2146e6b$export$6048538928ea261a = 4096;
const $dccf36f4b2146e6b$export$fd3a5bd85e4c7caa = 2;
const $dccf36f4b2146e6b$export$4030221cfc1fb63c = 5;
const $dccf36f4b2146e6b$export$ece7c64a85a33d85 = 255;
const $dccf36f4b2146e6b$export$6747badc61b8e57b = 512;
const $dccf36f4b2146e6b$export$48ffef5fac2e11a = 10;
const $dccf36f4b2146e6b$export$c38e76af505e38a1 = [
    'native',
    'link',
    'platform'
];
const $dccf36f4b2146e6b$export$3dcfc8418d714114 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$c38e76af505e38a1);
const $dccf36f4b2146e6b$export$c89f8194e7716284 = [
    'off',
    'full',
    'overflow'
];
const $dccf36f4b2146e6b$export$6cabc9b146da4ac8 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$c89f8194e7716284);
const $dccf36f4b2146e6b$export$9c3e0a77c247e0c = [
    'appDefinedSection',
    'suggestionSection'
];
const $dccf36f4b2146e6b$export$1e5c4f2c7d35f342 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$9c3e0a77c247e0c);
const $dccf36f4b2146e6b$export$dab292c7293b69ae = [
    '~',
    '|',
    ',',
    ':'
];


/**
 * Get configuration for a specific component kind
 */ function $bcdba2959b20769a$var$getComponentConfig(unknowns, kind) {
    switch(kind){
        case 'prefix':
            return {
                array: unknowns.prefixes,
                maxLimit: (0, $dccf36f4b2146e6b$export$fd3a5bd85e4c7caa),
                errorMessage: `Too many unknown ATI prefixes (max ${0, $dccf36f4b2146e6b$export$fd3a5bd85e4c7caa})`
            };
        case 'owner':
            return {
                array: unknowns.owners,
                maxLimit: (0, $dccf36f4b2146e6b$export$3010378ceda42048),
                errorMessage: `Too many unknown resource owners (max ${0, $dccf36f4b2146e6b$export$3010378ceda42048})`
            };
        case 'type':
            return {
                array: unknowns.types,
                maxLimit: (0, $dccf36f4b2146e6b$export$6048538928ea261a),
                errorMessage: `Too many unknown resource types (max ${0, $dccf36f4b2146e6b$export$6048538928ea261a})`
            };
    }
}
/**
 * Ensure capacity for a component kind
 * @throws Error if capacity limit is exceeded
 */ function $bcdba2959b20769a$var$ensureCapacity(unknowns, kind) {
    const config = $bcdba2959b20769a$var$getComponentConfig(unknowns, kind);
    if (config.array.length >= config.maxLimit) throw new Error(config.errorMessage);
}
/**
 * Track unknown component value and return its index
 * Reuses existing index if value already tracked
 */ function $bcdba2959b20769a$var$trackUnknown({ unknowns: unknowns, kind: kind, value: value }) {
    const config = $bcdba2959b20769a$var$getComponentConfig(unknowns, kind);
    const existing = config.array.indexOf(value);
    if (existing !== -1) return existing;
    $bcdba2959b20769a$var$ensureCapacity(unknowns, kind);
    config.array.push(value);
    return config.array.length - 1;
}
/**
 * Encode a component (prefix/owner/type) to its code
 * Returns code and unknown flag
 */ function $bcdba2959b20769a$var$encodeComponent({ unknowns: unknowns, kind: kind, value: value, knownMap: knownMap }) {
    const knownCode = knownMap[value];
    const isUnknown = knownCode === undefined;
    const code = isUnknown ? $bcdba2959b20769a$var$trackUnknown({
        unknowns: unknowns,
        kind: kind,
        value: value
    }) : knownCode;
    return {
        code: code,
        isUnknown: isUnknown
    };
}
function $bcdba2959b20769a$export$4b052fcb66ebb451(ati, unknowns) {
    const { prefix: prefix, owner: owner, type: type } = (0, $0bf79e81331e4541$export$5597e67f4dded1e6)(ati);
    const { code: prefixCode, isUnknown: prefixIsUnknown } = $bcdba2959b20769a$var$encodeComponent({
        unknowns: unknowns,
        kind: 'prefix',
        value: prefix,
        knownMap: (0, $dccf36f4b2146e6b$export$61beacecbf214ae6)
    });
    const { code: ownerCode, isUnknown: ownerIsUnknown } = $bcdba2959b20769a$var$encodeComponent({
        unknowns: unknowns,
        kind: 'owner',
        value: owner,
        knownMap: (0, $dccf36f4b2146e6b$export$83dfff18be6bef06)
    });
    const { code: typeCode, isUnknown: typeIsUnknown } = $bcdba2959b20769a$var$encodeComponent({
        unknowns: unknowns,
        kind: 'type',
        value: type,
        knownMap: (0, $dccf36f4b2146e6b$export$38830b2321100ef2)
    });
    return {
        prefixCode: prefixCode,
        prefixIsUnknown: prefixIsUnknown,
        ownerCode: ownerCode,
        ownerIsUnknown: ownerIsUnknown,
        typeCode: typeCode,
        typeIsUnknown: typeIsUnknown
    };
}
function $bcdba2959b20769a$export$9fa514be131db9ec({ encoded: encoded, buffer: buffer, offset: offset }) {
    const { prefixCode: prefixCode, prefixIsUnknown: prefixIsUnknown, ownerIsUnknown: ownerIsUnknown, typeIsUnknown: typeIsUnknown, ownerCode: ownerCode, typeCode: typeCode } = encoded;
    // Byte 0: [P|O|T|P|OOOO]
    const ownerUpper = ownerCode >> (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).OWNER_UPPER_BITS & 0x0f;
    const byte0 = (prefixIsUnknown ? 1 : 0) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).PREFIX_FLAG_SHIFT | (ownerIsUnknown ? 1 : 0) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).OWNER_FLAG_SHIFT | (typeIsUnknown ? 1 : 0) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).TYPE_FLAG_SHIFT | (prefixCode & 0x01) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).PREFIX_VALUE_SHIFT | ownerUpper;
    // Byte 1: [OOOO|TTTT]
    const ownerLower = ownerCode & 0x0f;
    const typeUpper = typeCode >> 8 & 0x0f;
    const byte1 = ownerLower << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).OWNER_LOWER_SHIFT | typeUpper;
    // Byte 2: [TTTTTTTT]
    const byte2 = typeCode & 0xff;
    // Write bytes directly (inline writeUInt8)
    buffer[offset] = byte0 & 0xff;
    buffer[offset + 1] = byte1 & 0xff;
    buffer[offset + 2] = byte2 & 0xff;
}


/**
 * Platform-agnostic buffer utilities for binary encoding/decoding
 * Works in both browser and Node.js environments
 */ /**
 * Encode Uint8Array to base64url string (without padding)
 *
 * @param bytes - Uint8Array to encode
 * @returns Base64URL-encoded string
 */ 
var $iA9co = parcelRequire("iA9co");

var $5120b89f81d97ddd$require$Buffer = $iA9co.Buffer;
function $5120b89f81d97ddd$export$b0ffcdf8b133e63c(bytes) {
    if (bytes.length === 0) return '';
    if (btoa === undefined) return $5120b89f81d97ddd$require$Buffer.from(bytes).toString('base64url');
    else {
        // Browser: convert to binary string using Array.from (safe for large arrays and null bytes)
        const binaryString = Array.from(bytes, (byte)=>String.fromCharCode(byte)).join('');
        return btoa(binaryString).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }
}



// =============================================================================
// Configuration Validation
// =============================================================================
const $e39212095b0d4be5$var$MAX_SECTIONS = 15;
function $e39212095b0d4be5$var$validateConfig(config) {
    if (!config || typeof config !== 'object') throw new Error('Config must be an object');
    if (!Array.isArray(config.appMenuConfig)) throw new Error('Config sections must be an array');
    if (config.appMenuConfig.length === 0) throw new Error('Cannot encode empty sections array');
    if (config.appMenuConfig.length > $e39212095b0d4be5$var$MAX_SECTIONS) throw new Error(`Too many sections (max ${$e39212095b0d4be5$var$MAX_SECTIONS})`);
}
// =============================================================================
// ATI Encoding
// =============================================================================
/**
 * Encode a single ATI string to 3-byte binary format, then Base64URL
 *
 * @param ati - ATI string to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Base64URL-encoded ATI (4 characters)
 */ function $e39212095b0d4be5$var$encodeATIToBase64(ati, unknowns) {
    const encoded = (0, $bcdba2959b20769a$export$4b052fcb66ebb451)(ati, unknowns);
    const buffer = new Uint8Array(3);
    (0, $bcdba2959b20769a$export$9fa514be131db9ec)({
        encoded: encoded,
        buffer: buffer,
        offset: 0
    });
    return (0, $5120b89f81d97ddd$export$b0ffcdf8b133e63c)(buffer);
}
/**
 * Encode a list of ATI strings to comma-separated Base64URL format
 *
 * @param atiList - Array of ATI strings (optional)
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Comma-separated Base64URL-encoded ATIs, or empty string if no ATIs
 */ function $e39212095b0d4be5$var$encodeATIList(atiList, unknowns) {
    if (!atiList || atiList.length === 0) return '';
    return atiList.map((ati)=>$e39212095b0d4be5$var$encodeATIToBase64(ati, unknowns)).join(',');
}
// =============================================================================
// Encoding Utilities
// =============================================================================
/**
 * Join array parts with hierarchical delimiter, truncating trailing empty/undefined values
 *
 * This utility implements a common pattern across encoding functions:
 * 1. Construct an array with known data
 * 2. Truncate array at last non-empty item
 * 3. Join array as string with delimiter at specified hierarchy level
 *
 * @param parts - Array of values to join (string | number | undefined)
 * @param delimiterLevel - Hierarchy level of delimiter to use (0=~, 1=|, 2=,, 3=:)
 * @returns Joined string with trailing empties removed
 *
 * @example
 * joinWithTruncation(['a', 'b', ''], 3) // 'a:b' (level 3 = ':')
 * joinWithTruncation(['a', '', ''], 2) // 'a' (level 2 = ',')
 * joinWithTruncation([1, 2, undefined], 1) // '1|2' (level 1 = '|')
 */ function $e39212095b0d4be5$var$joinWithTruncation(parts, delimiterLevel) {
    // When delimiter level is out of bounds, default to '~'
    const delimiter = (0, $dccf36f4b2146e6b$export$dab292c7293b69ae)[delimiterLevel] ?? '~';
    // Find last index where value is not empty string or undefined
    let lastIndex = parts.length - 1;
    while(lastIndex >= 0 && (parts[lastIndex] === '' || parts[lastIndex] === undefined))lastIndex--;
    // Slice to last non-empty index + 1, convert all to string, and join
    return parts.slice(0, lastIndex + 1).map(String).join(delimiter);
}
// =============================================================================
// Menu Item Encoding
// =============================================================================
const $e39212095b0d4be5$var$PROMOTED_FLAG = '1';
/**
 * Encode a single menu item
 *
 * Format: atiBase64:itemType[:promoted]
 * - The promoted flag is only included when true
 *
 * @param item - Menu item to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded menu item string
 * @throws Error if item type is unknown
 */ function $e39212095b0d4be5$var$encodeMenuItem(item, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const typeCode = item.type !== undefined ? $e39212095b0d4be5$var$getCodeByType(item) : undefined;
    const atiBase64 = $e39212095b0d4be5$var$encodeATIToBase64(item.ati, unknowns);
    const isPromoted = item.promoted === true;
    const promotedFlag = isPromoted ? $e39212095b0d4be5$var$PROMOTED_FLAG : undefined;
    return $e39212095b0d4be5$var$joinWithTruncation([
        atiBase64,
        typeCode,
        promotedFlag
    ], 3); // Level 3: ':' (item properties)
}
/**
 * Get the numeric type code for a menu item
 *
 * @param item - Menu item
 * @returns Numeric type code
 * @throws Error if item type is unknown or undefined
 */ function $e39212095b0d4be5$var$getCodeByType(item) {
    // If go down the path of getting code, type should not be undefined
    if (item.type === undefined) throw new Error('Item type is undefined');
    const typeCode = (0, $dccf36f4b2146e6b$export$3dcfc8418d714114)[item.type];
    if (typeCode === undefined) throw new Error(`Unknown item type: ${item.type}`);
    return typeCode;
}
/**
 * Get the numeric code for a menu section
 *
 * @param sectionType - Section type MenuSection['type']
 * @returns String type code number
 */ function $e39212095b0d4be5$var$sectionTypeToCode(sectionType) {
    const typeCode = (0, $dccf36f4b2146e6b$export$1e5c4f2c7d35f342)[sectionType];
    if (typeCode === undefined) throw new Error(`Unknown section type: ${String(sectionType)}`);
    return typeCode;
}
// =============================================================================
// Section Encoding
// =============================================================================
/**
 * Get the numeric code for a personalize mode
 *
 * @param mode - Personalize mode
 * @returns Numeric code for the mode
 * @throws Error if mode is unknown
 */ function $e39212095b0d4be5$var$personalizeCodeByMode(mode) {
    const code = (0, $dccf36f4b2146e6b$export$6cabc9b146da4ac8)[mode];
    if (code === undefined) throw new Error(`Unknown personalize mode: ${mode}`);
    return code;
}
/**
 * Encode an overflow threshold
 *
 * @param overflowThreshold - Overflow threshold
 * @returns Encoded overflow threshold string
 */ function $e39212095b0d4be5$var$encodeOverflowThreshold(overflowThreshold) {
    if (overflowThreshold < 0) throw new Error('Overflow threshold must be positive');
    return overflowThreshold.toString();
}
/**
 * Encode an app-defined section
 *
 * Format: 0|item1,item2,...|personalizeCode
 * - Trailing default values are truncated (personalize='0' / 'off' can be omitted)
 * - personalizeCode: 0=off, 1=full, 2=overflow
 *
 * @private
 * @param section - App-defined section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 */ function $e39212095b0d4be5$var$encodeAppDefinedSection(section, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const sectionType = $e39212095b0d4be5$var$sectionTypeToCode('appDefinedSection');
    const encodedItems = section.items.map((item)=>$e39212095b0d4be5$var$encodeMenuItem(item, unknowns)).join(',');
    const personalizeCode = section.personalize && section.personalize !== 'off' ? $e39212095b0d4be5$var$personalizeCodeByMode(section.personalize) : undefined;
    const overflowThreshold = personalizeCode !== undefined && section.personalize === 'overflow' && section.overflowThreshold !== undefined ? $e39212095b0d4be5$var$encodeOverflowThreshold(section.overflowThreshold) : undefined;
    return $e39212095b0d4be5$var$joinWithTruncation([
        sectionType,
        encodedItems,
        personalizeCode,
        overflowThreshold
    ], 1); // Level 1: '|' (section fields)
}
/**
 * Encode a suggestion section
 *
 * Format: 1|limit|excludeAti1,excludeAti2,...|preferredAti1,preferredAti2,...
 * - Trailing empty values are truncated (empty excludeAtis/preferredAtis can be omitted)
 * - Default limit (5) is included explicitly for clarity
 *
 * @private
 * @param section - Suggestion section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 */ function $e39212095b0d4be5$var$encodeSuggestionSection(section, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const sectionType = $e39212095b0d4be5$var$sectionTypeToCode('suggestionSection');
    const limit = section.limit;
    const excludeAtis = $e39212095b0d4be5$var$encodeATIList(section.excludeAtis, unknowns);
    const preferredAtis = $e39212095b0d4be5$var$encodeATIList(section.preferredAtis, unknowns);
    return $e39212095b0d4be5$var$joinWithTruncation([
        sectionType,
        limit,
        excludeAtis,
        preferredAtis
    ], 1); // Level 1: '|' (section fields)
}
/**
 * Encode a single menu section based on its type
 *
 * @param section - Menu section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 * @throws Error if section type is unknown
 */ function $e39212095b0d4be5$var$encodeSection(section, unknowns) {
    switch(section.type){
        case 'appDefinedSection':
            return $e39212095b0d4be5$var$encodeAppDefinedSection(section, unknowns);
        case 'suggestionSection':
            return $e39212095b0d4be5$var$encodeSuggestionSection(section, unknowns);
        default:
            // TypeScript exhaustiveness check - this should never happen
            throw new Error(`Unknown section type: ${String(section)}`);
    }
}
// =============================================================================
// Final Assembly
// =============================================================================
/**
 * Build the raw configuration string from encoded sections
 *
 * Format: v{SCHEMA_VERSION}~section1~section2~...
 *
 * @private
 * @param encodedSections - Array of encoded section strings
 * @returns Raw configuration string with version prefix
 */ function $e39212095b0d4be5$var$buildRawConfigString(encodedSections) {
    return `v${0, $dccf36f4b2146e6b$export$3167453beff01750}~${encodedSections.join('~')}`;
}
/**
 * Attach unknown component query parameters to the encoded result
 *
 * @private
 * @param encodedData - Base64URL-encoded configuration data
 * @param unknowns - Unknown ATI components collected during encoding
 * @returns Encoded configuration with query parameters
 */ function $e39212095b0d4be5$var$attachQueryParameters(encodedData, unknowns) {
    const result = {
        d: encodedData
    };
    if (unknowns.owners.length > 0) result.ro = unknowns.owners.join(',');
    if (unknowns.types.length > 0) result.rt = unknowns.types.join(',');
    if (unknowns.prefixes.length > 0) result.ap = unknowns.prefixes.join(',');
    return result;
}
function $e39212095b0d4be5$export$1282978798683232(config) {
    $e39212095b0d4be5$var$validateConfig(config);
    const unknowns = {
        owners: [],
        types: [],
        prefixes: []
    };
    const encodedSections = config.appMenuConfig.map((section)=>$e39212095b0d4be5$var$encodeSection(section, unknowns));
    const rawConfigString = $e39212095b0d4be5$var$buildRawConfigString(encodedSections);
    // Encode UTF-8 string to bytes, then to base64url
    const utf8Bytes = new TextEncoder().encode(rawConfigString);
    const encodedData = (0, $5120b89f81d97ddd$export$b0ffcdf8b133e63c)(utf8Bytes);
    return $e39212095b0d4be5$var$attachQueryParameters(encodedData, unknowns);
}



var $4jETc = parcelRequire("4jETc");


var $caUKj = parcelRequire("caUKj");


var $cei05 = parcelRequire("cei05");


var $6lFYf = parcelRequire("6lFYf");


var $dG1kO = parcelRequire("dG1kO");


var $ik19A = parcelRequire("ik19A");


var $cdX3N = parcelRequire("cdX3N");

function $3ef0e6a21c4da545$export$23f37315094bc4d3({ cloudId: cloudId, orgId: orgId, product: product, userId: userId, locale: locale, subProduct: subProduct, appMenuConfig: appMenuConfig, skipInitialization: skipInitialization = false }) {
    const { value: value, currentLoadingRequests: currentLoadingRequests } = (0, $caUKj.useBFFContext)();
    const boundaryConfig = (0, $42omo.useMemo)(()=>({
            location: 'useUCMenuItems',
            disableSentry: (0, $dh538.fg)('navx_uc_sentry_enabled') ? false : true,
            disableAnalytics: true,
            sentryConfig: {
                product: product
            },
            interactionId: 'universalCreatePrefetch',
            tags: {
                component: 'universal-create',
                subProduct: subProduct
            }
        }), [
        product,
        subProduct
    ]);
    const { handleError: handleError } = (0, $5IDSL.useNavBoundaryContext)(boundaryConfig);
    const { inFlightRequests: inFlightRequests, setInFlightRequests: setInFlightRequests } = (0, $cei05.useUniversalCreateBFFContext)();
    const { setStatus: setStatus } = (0, $ik19A.useStatus)();
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const { buildUCMenuItemsURL: buildUCMenuItemsURL } = (0, $cdX3N.useURLBuilder)({
        cloudId: cloudId
    });
    const requestIdRef = (0, $42omo.useRef)(0);
    const inFlightRequestKeyRef = (0, $42omo.useRef)(null);
    /**
	 * Helper functions for feature gated inflight request tracking
	 */ const isRequestInflight = (0, $42omo.useCallback)((requestKey)=>{
        return (0, $dh538.fg)('navx-2674-uc-menu-inflight-request-context') ? inFlightRequests.has(requestKey) : inFlightRequestKeyRef.current === requestKey;
    }, [
        inFlightRequests
    ]);
    const setRequestInFlight = (0, $42omo.useCallback)((requestKey, value)=>{
        return (0, $dh538.fg)('navx-2674-uc-menu-inflight-request-context') ? setInFlightRequests(requestKey, value) : inFlightRequestKeyRef.current = requestKey;
    }, [
        setInFlightRequests
    ]);
    const clearInFlightRequest = (0, $42omo.useCallback)((requestKey)=>{
        return (0, $dh538.fg)('navx-2674-uc-menu-inflight-request-context') ? inFlightRequests.delete(requestKey) : inFlightRequestKeyRef.current = null;
    }, [
        inFlightRequests
    ]);
    // Encode the config to get binary parameters
    const encodedConfig = (0, $42omo.useMemo)(()=>{
        if (skipInitialization) return null;
        try {
            return (0, $e39212095b0d4be5$export$1282978798683232)(appMenuConfig);
        } catch  {
            // If encoding fails, we'll handle it in the fetch
            return null;
        }
    }, [
        appMenuConfig,
        skipInitialization
    ]);
    // Generate cache key based on encoded config and metadata
    const { cachedObject: cachedObject, setCachedObject: setCachedObject } = (0, $dG1kO.useGenericCache)({
        cloudId: cloudId,
        productType: product,
        orgId: orgId,
        accountId: userId,
        subProduct: subProduct,
        locale: locale,
        // Include encoded config in cache key to ensure different configs get different cache entries
        ...encodedConfig && {
            encodedConfigD: encodedConfig.d
        }
    });
    // Set data from cache on mount if available
    if (cachedObject && !data) {
        setData(cachedObject);
        setHasError(false);
    }
    const fetchUCMenuItems = (0, $42omo.useCallback)(async ()=>{
        // Early exit: filter out invalid param requests when required identifiers are missing or skip initialization if requested
        if (!cloudId || !orgId || skipInitialization) return;
        // Early exit: if encoding failed
        if (!encodedConfig) {
            setHasError(true);
            setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            return;
        }
        // Return cached data if available (already locale-scoped via cache key)
        if (cachedObject) {
            setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            return cachedObject;
        }
        // Generate request key to prevent duplicate concurrent requests
        const requestKey = `${product}|${orgId}|${userId}|${locale}|${subProduct}|${encodedConfig.d}`;
        // Skip if an identical request is already in flight
        if (isRequestInflight(requestKey)) return;
        // Increment request id for race protection
        requestIdRef.current += 1;
        const scopedId = requestIdRef.current;
        // Create and start experience tracker only when actually making request
        const experience = (0, $dh538.fg)('navx-2747-ufo-prefetch-tracking') ? (0, $l7sDu.createExperienceTracker)('universalCreatePrefetch') : null;
        experience?.start();
        try {
            const url = buildUCMenuItemsURL({
                product: product,
                orgId: orgId,
                userId: userId,
                locale: locale,
                subProduct: subProduct,
                d: encodedConfig.d,
                ro: encodedConfig.ro,
                rt: encodedConfig.rt,
                ap: encodedConfig.ap
            });
            setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            // Mark request key as in-flight before fetch fires to prevent race conditions
            setRequestInFlight(requestKey, true);
            const response = await (0, $6lFYf.fetchJSON)(url, {});
            // Ignore if this response is for a stale request
            if (scopedId !== requestIdRef.current) {
                // Clear in-flight key if this was the request that set it
                if (isRequestInflight(requestKey)) clearInFlightRequest(requestKey);
                return;
            }
            if (response.status === (0, $4jETc.RequestStatus).ERROR) {
                experience?.failure();
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
                // Clear in-flight key on error
                clearInFlightRequest(requestKey);
                if ((0, $dh538.fg)('navx_uc_sentry_enabled')) handleError(new (0, $ekTM6.BFFNetworkError)('Failed to fetch universal create menu items', {
                    url: url,
                    status: response.status,
                    originalError: response.error,
                    additionalContext: {
                        requestKey: requestKey
                    }
                }));
                return;
            }
            if (response.status === (0, $4jETc.RequestStatus).COMPLETE && response.data) {
                experience?.success();
                setData(response.data);
                setHasError(false);
                // Only cache if the data is not partial
                if (!response.data.isPartial) setCachedObject(response.data);
                setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
                // Clear in-flight key on success
                clearInFlightRequest(requestKey);
                return response.data;
            }
        } catch (error) {
            experience?.failure();
            if (scopedId === requestIdRef.current) {
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            }
            // Clear in-flight key on exception
            clearInFlightRequest(requestKey);
            if ((0, $dh538.fg)('navx_uc_sentry_enabled')) handleError(new (0, $ekTM6.BFFError)('Error occurred during fetchUCMenuItems', {
                status: (0, $4jETc.RequestStatus).ERROR,
                originalError: error,
                additionalContext: {
                    requestKey: requestKey
                }
            }));
        }
        return;
    }, [
        cloudId,
        orgId,
        skipInitialization,
        encodedConfig,
        cachedObject,
        product,
        userId,
        locale,
        subProduct,
        isRequestInflight,
        setStatus,
        buildUCMenuItemsURL,
        setRequestInFlight,
        clearInFlightRequest,
        handleError,
        setCachedObject
    ]);
    const isLoading = (0, $42omo.useMemo)(()=>{
        if (skipInitialization) return false;
        // We check if the current loading requests include UC menu items rather than the BFF status directly
        // to ensure that it only returns true for UC menu items and not other BFF requests.
        const isBffLoadingOurStuff = currentLoadingRequests?.includes((0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY)) ?? false;
        // That said, if the BFF is in loading state but data has been returned, we want to wait for things to complete
        // before running things like onResultChange, so that we don't do those things an unnecessary extra time
        // during the brief moment when data is present but loading is still true, or an error has occurred and loading is still true.
        const hasMenuItemDataBeenReturned = data !== undefined || hasError;
        return isBffLoadingOurStuff && !hasMenuItemDataBeenReturned;
    }, [
        currentLoadingRequests,
        data,
        hasError,
        skipInitialization
    ]);
    return {
        data: data,
        isLoading: isLoading,
        hasError: hasError,
        status: value.status,
        fetchUCMenuItems: fetchUCMenuItems
    };
}
module.exports["useUCMenuItems"] = $3ef0e6a21c4da545$export$23f37315094bc4d3;

});

parcelRegister("a5rWO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $4d8cf794b5538381$export$e5a5b1df38d9e289 = 4;



var $6oodB = parcelRequire("6oodB");

const $6f8e2274fdd0fece$export$20ae29efbf02e075 = (item)=>({
        type: (0, $6oodB.isNativeMenuItem)(item) ? 'native' : item.type,
        ati: item.ati.toString(),
        promoted: item?.promoted
    });
const $6f8e2274fdd0fece$export$95539883fd80ce6 = (section)=>{
    if (section.type === 'suggestionSection') return {
        type: 'suggestionSection',
        limit: section.limit ?? 5,
        ...section.excludeAtis && {
            excludeAtis: section.excludeAtis.map((ati)=>ati.toString())
        },
        ...section.preferredAtis && {
            preferredAtis: section.preferredAtis.map((ati)=>ati.toString())
        }
    };
    if (section.type === 'appDefinedSection') {
        if ((0, $dh538.fg)('navx-2827-add-menu-v2-overflow-threshold')) {
            const overflowThreshold = Boolean(section.foldable) ? typeof section.foldable === 'number' ? section.foldable : (0, $4d8cf794b5538381$export$e5a5b1df38d9e289) : undefined;
            return {
                type: 'appDefinedSection',
                items: section.items.map($6f8e2274fdd0fece$export$20ae29efbf02e075),
                personalize: section.personalize,
                ...overflowThreshold && {
                    overflowThreshold: overflowThreshold
                }
            };
        } else return {
            type: 'appDefinedSection',
            items: section.items.map($6f8e2274fdd0fece$export$20ae29efbf02e075),
            personalize: section.personalize
        };
    }
    // Assert that we have handled all possible section types
    const exhaustive = section;
    return exhaustive;
};
const $6f8e2274fdd0fece$export$c9ba238fd04e08d2 = (sections)=>({
        appMenuConfig: sections.map($6f8e2274fdd0fece$export$95539883fd80ce6)
    });
module.exports["sectionsToAppMenuConfig"] = $6f8e2274fdd0fece$export$c9ba238fd04e08d2;

});

parcelRegister("6oodB", function(module, exports) {
const $79b80363c4ad79e3$export$68f958d92a17ef71 = (item)=>{
    return 'children' in item && !('type' in item);
};
module.exports["isNativeMenuItem"] = $79b80363c4ad79e3$export$68f958d92a17ef71;

});

parcelRegister("amdkE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $9DI9J = parcelRequire("9DI9J");


var $7WMLZ = parcelRequire("7WMLZ");

const $cfb31863b8c4fcaa$var$styles = {
    wrapper: "_1ul91dhz",
    wrapperWithPadding: "_1ul91dhz _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi"
};
function $cfb31863b8c4fcaa$export$dab1248df0cdf0ab({ padded: padded = false }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // Intentional inline this analytics events due to
        // loading menu component can be used outside of context
        if ((0, $dh538.fg)('navx-3262-loading-menu-viewed')) createAnalyticsEvent({
            actionSubject: 'universalCreate',
            eventType: 'ui',
            source: (0, $9DI9J.ANALYTICS_SOURCE),
            tags: [
                (0, $9DI9J.ANALYTICS_TAG)
            ],
            action: 'viewed',
            actionSubjectId: 'universalCreateLoadingMenu',
            attributes: {}
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "global-create-content-loading-menu",
        xcss: padded ? $cfb31863b8c4fcaa$var$styles.wrapperWithPadding : $cfb31863b8c4fcaa$var$styles.wrapper,
        children: Array.from({
            length: 6
        }, (_, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7WMLZ.SkeletonItem), {
                contentHeight: 8
            }, `loading-skeleton-item-${index}`))
    });
}
module.exports["LoadingMenu"] = $cfb31863b8c4fcaa$export$dab1248df0cdf0ab;

});

parcelRegister("7WMLZ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1s5hv = parcelRequire("1s5hv");

var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");


var $6F6hl = parcelRequire("6F6hl");


var $cgtv4 = parcelRequire("cgtv4");

const $63d1bead1b1651fc$var$messages = (0, $cgtv4.defineMessages)({
    menuItemLoading: {
        id: "navigation.universal-create.menuItemLoading",
        defaultMessage: "Menu item is loading"
    }
});
var $63d1bead1b1651fc$export$2e2bcd8739ae039 = $63d1bead1b1651fc$var$messages;


const $f0781448a6f252f4$var$DEFAULT_CONTENT_HEIGHT = 8;
const $f0781448a6f252f4$var$menuSkeletonStyles = {
    wrapper: "_4t3izwfg _1bsb1osq _19bv1b66 _u5f31b66"
};
const $f0781448a6f252f4$export$cde35cc9e1359709 = ({ testId: testId, contentHeight: contentHeight = $f0781448a6f252f4$var$DEFAULT_CONTENT_HEIGHT })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: $f0781448a6f252f4$var$menuSkeletonStyles.wrapper,
        alignBlock: "center",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                alignItems: "center",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    testId: "skeleton-item-v2",
                    width: "100%",
                    height: contentHeight,
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $63d1bead1b1651fc$export$2e2bcd8739ae039).menuItemLoading)
            })
        ]
    });
};


const $e8f4c6ac79c4c49f$export$fbc0ea7debdb77e = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $f0781448a6f252f4$export$cde35cc9e1359709), {
        ...props
    });
};
module.exports["SkeletonItem"] = $e8f4c6ac79c4c49f$export$fbc0ea7debdb77e;

});

parcelRegister("37BdC", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $4KS7f = parcelRequire("4KS7f");


var $9gE7g = parcelRequire("9gE7g");


var $g5gZt = parcelRequire("g5gZt");


var $ghftu = parcelRequire("ghftu");


var $hmuev = parcelRequire("hmuev");


var $aaBfd = parcelRequire("aaBfd");


var $1lhEF = parcelRequire("1lhEF");

var $5izcQ = parcelRequire("5izcQ");


var $dh538 = parcelRequire("dh538");


var $291hi = parcelRequire("291hi");

var $26eSY = parcelRequire("26eSY");

var $fFc6D = parcelRequire("fFc6D");


var $3gadb = parcelRequire("3gadb");


var $jjCkw = parcelRequire("jjCkw");


var $19BZl = parcelRequire("19BZl");


var $7K3dX = parcelRequire("7K3dX");


var $fNh3C = parcelRequire("fNh3C");

const $be8eb3f37dd41711$var$triggerButton = null; /**
                             * Refactor this whole logic after T-25, we should use the proper Create component instead.
                             * https://jplat.atlassian.net/browse/BLU-7401
                             */ 
const $be8eb3f37dd41711$var$nav3ButtonTextStyles = null;
const $be8eb3f37dd41711$var$messages = (0, $cgtv4.defineMessages)({
    secondaryButtonTooltipText: {
        id: "platform.navigation-experiences.universal-create.secondary-tooltip-text",
        defaultMessage: "More create options"
    }
});
function $be8eb3f37dd41711$var$TooltipWrapper({ children: children, text: text, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = true }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: text,
        isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled,
        position: "bottom",
        ignoreTooltipPointerEvents: true,
        children: children
    });
}
function $be8eb3f37dd41711$var$TriggerButtonInner({ triggerProps: triggerProps, testId: testId, onClick: onClick, children: children, isOpen: isOpen, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, enableTriggerPulse: enableTriggerPulse, isNav4Enabled: isNav4Enabled = true, buttonTheme: buttonTheme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, primaryActionItem: primaryActionItem, isEntryPointEnabled: isEntryPointEnabled = false }) {
    const { product: product, sections: sections } = (0, $19BZl.useUniversalCreateState)();
    const { fireCreateButtonClicked: fireCreateButtonClicked, fireCreateButtonHovered: fireCreateButtonHovered, fireCreateButtonViewed: fireCreateButtonViewed } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isDesktop = (0, $fFc6D.UNSAFE_useMediaQuery)('above.sm')?.matches ?? false;
    const version = sections?.length ? 'v2' : 'v1';
    const hasHoveredRef = (0, $42omo.useRef)(false);
    const isSplitButton = Boolean(primaryActionItem);
    const buttonVariant = isSplitButton ? 'split' : 'standard';
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('navx-3261_view-button-event')) return;
        fireCreateButtonViewed({
            buttonVariant: buttonVariant,
            version: version
        });
    }, [
        fireCreateButtonViewed,
        buttonVariant,
        version
    ]); // Extract splitPrimaryRef from triggerProps for split button variant
    const { splitButtonPrimaryRef: splitButtonPrimaryRef, ...restTriggerProps } = triggerProps;
    const onButtonClick = (0, $42omo.useCallback)(()=>{
        /// For entrypoint path (isEntryPointEnabled is true), set to expanded when isOpen is true
        // For non-entrypoint path (isEntryPointEnabled is false), set to expanded when isOpen is false (current state), as in the legacy mode, the event is fired before menu opens.
        const itemState = isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
        fireCreateButtonClicked({
            itemState: itemState
        });
        onClick();
    }, [
        fireCreateButtonClicked,
        isOpen,
        onClick,
        isEntryPointEnabled
    ]);
    const CreateIcon = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))) : (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt)));
    const createEnterEvent = (0, $42omo.useCallback)(({ buttonPart: buttonPart, shouldTriggerMouseEnterProp: shouldTriggerMouseEnterProp = true })=>(event)=>{
            if (!hasHoveredRef.current && (0, $dh538.fg)('navx-3093_button_hover_event')) {
                hasHoveredRef.current = true;
                const itemState = isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
                fireCreateButtonHovered({
                    buttonPart: buttonPart,
                    buttonVariant: buttonVariant,
                    itemState: itemState,
                    version: version
                });
            }
            if (shouldTriggerMouseEnterProp) onMouseEnter?.(event);
        }, [
        onMouseEnter,
        fireCreateButtonHovered,
        isOpen,
        isEntryPointEnabled,
        version,
        buttonVariant
    ]);
    const enterEvent = createEnterEvent({
        buttonPart: 'full'
    }); // Primary button should only fire analytics, not trigger onMouseEnter prop (which triggers lazy loading)
    const enterEventPrimaryAnalyticsOnly = createEnterEvent({
        buttonPart: 'primary',
        shouldTriggerMouseEnterProp: false
    });
    const enterEventDropdown = createEnterEvent({
        buttonPart: 'dropdown'
    });
    const leaveEvent = (0, $42omo.useCallback)((event)=>{
        onMouseLeave?.(event);
    }, [
        onMouseLeave
    ]);
    const button = /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_12y21ule _uis9u2gc _1rrju2gc _15nzidpf _dlu2idpf"
        ]),
        children: product === 'confluence' && !isNav4Enabled ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                "_x0l4u2gc _19ywu2gc _1xc3idpf _pj60idpf _muvxglyw"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4KS7f.default), {
                ...restTriggerProps,
                appearance: "primary",
                theme: buttonTheme,
                onMouseEnter: enterEvent,
                onMouseLeave: leaveEvent,
                onClick: onButtonClick,
                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(CreateIcon, {
                    label: "",
                    "data-vc": "global-content-create-button"
                }),
                testId: testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID),
                "aria-label": children,
                isSelected: isOpen,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                    above: "sm",
                    as: "span",
                    children: children
                })
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
            text: children,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.Button), {
                ...restTriggerProps,
                appearance: "primary",
                onClick: onButtonClick,
                onMouseEnter: enterEvent,
                onMouseLeave: leaveEvent,
                isSelected: isOpen,
                iconBefore: CreateIcon,
                testId: testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID),
                "aria-label": children,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                    above: "sm",
                    as: "span",
                    children: children
                })
            })
        })
    });
    const responsiveSafeButton = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                above: (0, $jjCkw.RESPONSIVE_BREAKPOINT),
                children: /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                    text: children,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.Button), {
                        ...isDesktop ? restTriggerProps : {},
                        appearance: "primary",
                        onClick: onButtonClick,
                        onMouseEnter: enterEvent,
                        onMouseLeave: leaveEvent,
                        isSelected: isOpen,
                        iconBefore: CreateIcon,
                        testId: testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID),
                        "aria-label": children,
                        "data-responsive-variant": "desktop",
                        children: children
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $291hi.Hide), {
                above: (0, $jjCkw.RESPONSIVE_BREAKPOINT),
                children: /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                    text: children,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.IconButton), {
                        ...!isDesktop ? restTriggerProps : {},
                        appearance: "primary",
                        onClick: onButtonClick,
                        onMouseEnter: enterEvent,
                        onMouseLeave: leaveEvent,
                        isSelected: isOpen,
                        icon: CreateIcon,
                        testId: `${testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID)}-mobile`,
                        label: children,
                        "data-responsive-variant": "mobile"
                    })
                })
            })
        ]
    });
    const splitButtonVariant = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                above: (0, $jjCkw.RESPONSIVE_BREAKPOINT),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $9gE7g.SplitButton), {
                    appearance: "primary",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                            text: children,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.Button), {
                                ref: splitButtonPrimaryRef,
                                appearance: "primary",
                                onClick: primaryActionItem?.onClick,
                                onMouseEnter: enterEventPrimaryAnalyticsOnly,
                                "aria-label": children,
                                testId: "uc-trigger-button-primary",
                                children: children
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                            text: formatMessage($be8eb3f37dd41711$var$messages.secondaryButtonTooltipText),
                            isScreenReaderAnnouncementDisabled: false,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.IconButton), {
                                ...isDesktop ? restTriggerProps : {},
                                appearance: "primary",
                                onClick: onButtonClick,
                                isSelected: isOpen,
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))),
                                "data-responsive-variant": "desktop",
                                label: children,
                                testId: `${testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID)}-split`,
                                onMouseEnter: enterEventDropdown,
                                onMouseLeave: leaveEvent
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $291hi.Hide), {
                above: "sm",
                children: /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                    text: children,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.IconButton), {
                        ...!isDesktop ? restTriggerProps : {},
                        appearance: "primary",
                        onClick: onButtonClick,
                        onMouseEnter: enterEvent,
                        onMouseLeave: leaveEvent,
                        isSelected: isOpen,
                        icon: CreateIcon,
                        testId: `${testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID)}-mobile`,
                        label: children,
                        "data-responsive-variant": "mobile"
                    })
                })
            })
        ]
    });
    const buttonToRender = primaryActionItem ? splitButtonVariant : isNav4Enabled ? responsiveSafeButton : button;
    return triggerButtonSpotlightTarget ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5izcQ.default), {
        name: triggerButtonSpotlightTarget,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1lhEF.Pulse), {
            radius: 3,
            pulse: enableTriggerPulse,
            children: buttonToRender
        })
    }) : buttonToRender;
}
const $be8eb3f37dd41711$export$4129321aecd13375 = (0, $fNh3C.withIntlProvider)($be8eb3f37dd41711$var$TriggerButtonInner);
module.exports["TriggerButton"] = $be8eb3f37dd41711$export$4129321aecd13375;

});

parcelRegister("fNh3C", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $keVvA = parcelRequire("keVvA");


var $i2kCO = parcelRequire("i2kCO");

function $503da3927b063db6$export$bca6b946a784e234(locale) {
    if ([
        'en-GB',
        'en-ZZ',
        'pt-PT',
        'zh-TW'
    ].includes(locale)) return locale;
    else if (locale === 'zh-HK') return 'zh-TW';
    return locale.split('-')[0];
}

























function $503da3927b063db6$var$fetchLanguageFile(code) {
    switch(code){
        case 'cs':
            return (parcelRequire("ahMRD"));
        case 'da':
            return (parcelRequire("2lzUO"));
        case 'de':
            return (parcelRequire("ctCPM"));
        case 'en-GB':
            return (parcelRequire("ijaow"));
        case 'en-ZZ':
            return (parcelRequire("hEfqd"));
        case 'en':
            return Promise.resolve((parcelRequire("i2kCO")));
        case 'es':
            return (parcelRequire("25NMb"));
        case 'fi':
            return (parcelRequire("2a0cX"));
        case 'fr':
            return (parcelRequire("k3zzF"));
        case 'hu':
            return (parcelRequire("eLo8y"));
        case 'it':
            return (parcelRequire("j1kDF"));
        case 'ja':
            return (parcelRequire("g0SoK"));
        case 'ko':
            return (parcelRequire("dOr8D"));
        case 'nb':
            return (parcelRequire("eAsKQ"));
        case 'nl':
            return (parcelRequire("b6GRB"));
        case 'pl':
            return (parcelRequire("juEKn"));
        case 'pt':
            return (parcelRequire("2ORjt"));
        case 'ru':
            return (parcelRequire("gnt5x"));
        case 'sv':
            return (parcelRequire("lTqxa"));
        case 'th':
            return (parcelRequire("5UKAA"));
        case 'tr':
            return (parcelRequire("ls3Hr"));
        case 'uk':
            return (parcelRequire("d0iA6"));
        case 'vi':
            return (parcelRequire("fmmjN"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("hbMa0"));
        case 'zh':
            return (parcelRequire("1QisB"));
        default:
            throw new Error(`Unable to find translation for locale ${code}`);
    }
}
const $503da3927b063db6$export$12346a674644c156 = 'operational';
const $503da3927b063db6$export$515664faa1398f37 = 'navigation';
function $503da3927b063db6$var$Provider({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const loaderFn = async (locale)=>{
        const intlLocale = new Intl.Locale(locale.replace('_', '-'));
        try {
            const module = await $503da3927b063db6$var$fetchLanguageFile($503da3927b063db6$export$bca6b946a784e234(intlLocale.toString()));
            return module.default;
        } catch (e) {
            createAnalyticsEvent({
                eventType: $503da3927b063db6$export$12346a674644c156,
                action: 'not_loaded',
                actionSubject: 'uc_i18n',
                attributes: {
                    locale: locale
                }
            }).fire($503da3927b063db6$export$515664faa1398f37);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        loaderFn: loaderFn,
        defaultMessages: (0, $i2kCO.default),
        children: children
    });
}
const $503da3927b063db6$export$a5d940130f33be3f = (WrappedComponent)=>(props)=>/*#__PURE__*/ (0, $l998X.jsx)($503da3927b063db6$var$Provider, {
            children: /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                ...props
            })
        });
module.exports["withIntlProvider"] = $503da3927b063db6$export$a5d940130f33be3f;

});

parcelRegister("i2kCO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2e0f4708d02b569e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2e0f4708d02b569e$export$2e2bcd8739ae039 = {
    VzzYJk: 'Create',
    'goal-create-success-flag-action': 'Go to goal',
    'goal-create-success-flag-title': 'Goal has been created',
    'navigation.universal-create.menuItemLoading': 'Menu item is loading',
    'platform.navigation-experiences.universal-create.area-label': 'Toggle for {text}{heading} options',
    'platform.navigation-experiences.universal-create.integrations.form-loading': 'Loading',
    'platform.navigation-experiences.universal-create.integrations.team.create-error-flag-title': 'Sorry, something went wrong',
    'platform.navigation-experiences.universal-create.integrations.team.create-success-flag-go-to-team': 'View team',
    'platform.navigation-experiences.universal-create.integrations.team.create-success-flag-title': 'Team has been created',
    'platform.navigation-experiences.universal-create.project.create-error-flag-description': 'There was an error while creating your project. Please try again.',
    'platform.navigation-experiences.universal-create.project.create-error-flag-title': "We couldn't create your project",
    'platform.navigation-experiences.universal-create.project.create-success-flag-content': 'Go to project',
    'platform.navigation-experiences.universal-create.project.create-success-flag-title': 'Project has been created',
    'platform.navigation-experiences.universal-create.secondary-tooltip-text': 'More create options',
    'platform.navigation-experiences.universal-create.show-less': 'Less',
    'platform.navigation-experiences.universal-create.show-more': 'More',
    'platform.navigation-experiences.universal-create.show-more.area-label': 'Show {text} {heading} options',
    'platform.navigation-experiences.universal-create.suggestion.section-heading': '{count, plural, one {Suggestion} other {Suggestions}}',
    'universal-create.loom-video-menu-item.create-loom-video': 'Loom video',
    'universal-create.loom-video-menu-item.share-video': 'Share'
};

});

parcelRegister("ahMRD", function(module, exports) {

let $77d1654c1c15e55e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $77d1654c1c15e55e$var$load("4XOEX").then(()=>parcelRequire('2nrO6'));

});

parcelRegister("2lzUO", function(module, exports) {

let $1b5966f880e76542$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b5966f880e76542$var$load("gqmha").then(()=>parcelRequire('cmlqi'));

});

parcelRegister("ctCPM", function(module, exports) {

let $91565123f5e14147$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91565123f5e14147$var$load("cweX3").then(()=>parcelRequire('lbNO6'));

});

parcelRegister("ijaow", function(module, exports) {

let $03708ca713a2c0be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03708ca713a2c0be$var$load("bai9u").then(()=>parcelRequire('egI7t'));

});

parcelRegister("hEfqd", function(module, exports) {

let $cd922291e66c8f11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd922291e66c8f11$var$load("9t1Ib").then(()=>parcelRequire('gkIoe'));

});

parcelRegister("25NMb", function(module, exports) {

let $1862a8ecd6636580$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1862a8ecd6636580$var$load("eHlQ9").then(()=>parcelRequire('B195q'));

});

parcelRegister("2a0cX", function(module, exports) {

let $192cad396a6bdd1a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $192cad396a6bdd1a$var$load("6abco").then(()=>parcelRequire('j0Mtc'));

});

parcelRegister("k3zzF", function(module, exports) {

let $e99faec648a13ad6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e99faec648a13ad6$var$load("fvLDA").then(()=>parcelRequire('8fG30'));

});

parcelRegister("eLo8y", function(module, exports) {

let $abf82d8fe658586b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $abf82d8fe658586b$var$load("jYjnT").then(()=>parcelRequire('kh2Eq'));

});

parcelRegister("j1kDF", function(module, exports) {

let $dd8e1ec3f9d1cb33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd8e1ec3f9d1cb33$var$load("6chG6").then(()=>parcelRequire('klvFQ'));

});

parcelRegister("g0SoK", function(module, exports) {

let $ba86d7c94acc26c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ba86d7c94acc26c5$var$load("bXBzb").then(()=>parcelRequire('fXwAq'));

});

parcelRegister("dOr8D", function(module, exports) {

let $a0e4fefaf988d9b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0e4fefaf988d9b0$var$load("fMgo4").then(()=>parcelRequire('8ZHVH'));

});

parcelRegister("eAsKQ", function(module, exports) {

let $a9eabb8433af1a71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9eabb8433af1a71$var$load("1HBhy").then(()=>parcelRequire('5kpn9'));

});

parcelRegister("b6GRB", function(module, exports) {

let $816181108f87e114$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $816181108f87e114$var$load("9YSn1").then(()=>parcelRequire('cql7z'));

});

parcelRegister("juEKn", function(module, exports) {

let $e3106d2ec9b70e82$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3106d2ec9b70e82$var$load("40Jja").then(()=>parcelRequire('gYqMF'));

});

parcelRegister("2ORjt", function(module, exports) {

let $20d99b2a51a6915d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20d99b2a51a6915d$var$load("ibJOL").then(()=>parcelRequire('oyKRX'));

});

parcelRegister("gnt5x", function(module, exports) {

let $bec55ba52dad228a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bec55ba52dad228a$var$load("ipGTo").then(()=>parcelRequire('9FWL3'));

});

parcelRegister("lTqxa", function(module, exports) {

let $ff035117e6327794$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff035117e6327794$var$load("1dEiK").then(()=>parcelRequire('5SliH'));

});

parcelRegister("5UKAA", function(module, exports) {

let $44e6525118de287d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44e6525118de287d$var$load("bNIzh").then(()=>parcelRequire('ecW9b'));

});

parcelRegister("ls3Hr", function(module, exports) {

let $f9df1529a958cc99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9df1529a958cc99$var$load("bjl5Z").then(()=>parcelRequire('lGdFo'));

});

parcelRegister("d0iA6", function(module, exports) {

let $9779b04e13c8d738$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9779b04e13c8d738$var$load("7A6MW").then(()=>parcelRequire('jf2AA'));

});

parcelRegister("fmmjN", function(module, exports) {

let $b2ea3905cd9abd94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b2ea3905cd9abd94$var$load("gu0nB").then(()=>parcelRequire('50EZL'));

});

parcelRegister("hbMa0", function(module, exports) {

let $c838d2638f928cbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c838d2638f928cbe$var$load("2xhtF").then(()=>parcelRequire('dZU7K'));

});

parcelRegister("1QisB", function(module, exports) {

let $1578f79daacfef72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1578f79daacfef72$var$load("iwPoV").then(()=>parcelRequire('7yjbB'));

});

parcelRegister("lz3e7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $5qzNs = parcelRequire("5qzNs");


var $lvsjl = parcelRequire("lvsjl");

const $a714a9fde214d42c$export$f8e186cd2da1abff = 100;
const $a714a9fde214d42c$var$MOBILE_WIDTH_BREAKPOINT = 767;
function $a714a9fde214d42c$export$2a50c0408cf3ddb8() {
    const [isResponsiveMode, setIsResponsiveMode] = (0, $42omo.useState)(window.innerWidth <= $a714a9fde214d42c$var$MOBILE_WIDTH_BREAKPOINT);
    const [handleResizeDebounced] = (0, $lvsjl.default)(()=>{
        const isCurrentlyMobile = window.innerWidth <= $a714a9fde214d42c$var$MOBILE_WIDTH_BREAKPOINT;
        setIsResponsiveMode((prev)=>prev !== isCurrentlyMobile ? isCurrentlyMobile : prev);
    }, $a714a9fde214d42c$export$f8e186cd2da1abff);
    (0, $42omo.useEffect)(()=>{
        let unbind;
        unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'resize',
                listener: handleResizeDebounced
            }
        ]);
        return unbind;
    }, [
        handleResizeDebounced
    ]);
    return isResponsiveMode;
}
const $a714a9fde214d42c$export$d6eadbd047ebd460 = (item, ...properties)=>(0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(item, ...properties);
module.exports["useIsResponsiveView"] = $a714a9fde214d42c$export$2a50c0408cf3ddb8;
module.exports["omitSafely"] = $a714a9fde214d42c$export$d6eadbd047ebd460;

});

parcelRegister("dG1kO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $caUKj = parcelRequire("caUKj");

/**
 * Helper function to create a deterministic cache key from an object
 * by sorting keys and stringifying the result
 */ function $67bf03c55a136376$var$createSortedCacheKey(unordered) {
    return JSON.stringify(Object.keys(unordered).sort().reduce((obj, key)=>{
        obj[key] = unordered[key];
        return obj;
    }, {}));
}
function $67bf03c55a136376$export$53a1e737d45016e2(props) {
    const { value: { consumer: consumer, cache: cache }, setValue: setValue } = (0, $caUKj.useBFFContext)();
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    // Compute cache key using useMemo with sorted JSON stringification
    const cacheKey = (0, $42omo.useMemo)(()=>{
        const sortedJsonString = $67bf03c55a136376$var$createSortedCacheKey(props);
        return `gc-${consumer}-${sortedJsonString}`;
    }, [
        consumer,
        props
    ]);
    const cachedObject = cache[cacheKey];
    const setCachedObject = (0, $42omo.useCallback)((objectToCache)=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: objectToCache
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    const removeCachedObject = (0, $42omo.useCallback)(()=>{
        setValue((prev)=>{
            const { [cacheKey]: removed, ...remainingCache } = prev.cache;
            return {
                ...prev,
                cache: remainingCache
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const getCachedObject = (targetCacheKey)=>cache[targetCacheKey];
    const hasCachedObject = (targetCacheKey)=>cache[targetCacheKey] !== undefined;
    return {
        setCachedObject: setCachedObject,
        removeCachedObject: removeCachedObject,
        getCachedObject: getCachedObject,
        hasCachedObject: hasCachedObject,
        cacheKey: cacheKey,
        cachedObject: cachedObject
    };
}
module.exports["useGenericCache"] = $67bf03c55a136376$export$53a1e737d45016e2;

});


//# sourceMappingURL=LazyTrigger.96ba8053.js.map
